import React, {useEffect, useState} from 'react'
import {useHistory, useLocation} from 'react-router-dom'
import './styles/auditoria.css'

import AuditoriaTierBanner from './components/AuditoriaTierBanner'
import {TipoAcessoAuditoria} from '../../interfaces/IClienteAcessoAuditoria'
import {solicitarDemonstracaoSeBloqueado} from '../../utils/agendarDemonstracao'

import AuditoriaFiltros, {obterLabelTributo} from './components/AuditoriaFiltros'
import AuditoriaResumoGeral from './components/AuditoriaResumoGeral'
import AuditoriaTabelaTributos from './components/AuditoriaTabelaTributos'
import AuditoriaResumoBancario from './components/AuditoriaResumoBancario'
import AuditoriaResumoDepreciacao from './components/AuditoriaResumoDepreciacao'
import AuditoriaDetalheTributo from './components/AuditoriaDetalheTributo'
import AuditoriaSaldosBancarios from './components/AuditoriaSaldosBancarios'
import AuditoriaDepreciacaoDetalhe from './components/AuditoriaDepreciacaoDetalhe'
import AuditoriaResumoCaixa from './components/AuditoriaResumoCaixa'
import AuditoriaCaixaDetalhe from './components/AuditoriaCaixaDetalhe'
import AuditoriaResumoFinanceira from './components/AuditoriaResumoFinanceira'
import AuditoriaFinanceiraDetalhe from './components/AuditoriaFinanceiraDetalhe'
import AuditoriaResumoZeramento13 from './components/AuditoriaResumoZeramento13'
import AuditoriaZeramento13Detalhe from './components/AuditoriaZeramento13Detalhe'
import AuditoriaResumoBaixaPatrimonial from './components/AuditoriaResumoBaixaPatrimonial'
import AuditoriaBaixaPatrimonialDetalhe from './components/AuditoriaBaixaPatrimonialDetalhe'
import AuditoriaResumoAdiantamento from './components/AuditoriaResumoAdiantamento'
import AuditoriaAdiantamentoDetalhe from './components/AuditoriaAdiantamentoDetalhe'
import AuditoriaResumoAdiantamentoClientes from './components/AuditoriaResumoAdiantamentoClientes'
import AuditoriaAdiantamentoClientesDetalhe from './components/AuditoriaAdiantamentoClientesDetalhe'
import AuditoriaResumoDespesasAntecipadas from './components/AuditoriaResumoDespesasAntecipadas'
import AuditoriaDespesasAntecipadasDetalhe from './components/AuditoriaDespesasAntecipadasDetalhe'
import AuditoriaResumoAjusteExerciciosAnteriores from './components/AuditoriaResumoAjusteExerciciosAnteriores'
import AuditoriaAjusteExerciciosAnterioresDetalhe from './components/AuditoriaAjusteExerciciosAnterioresDetalhe'
import AuditoriaResumoContasPagarReceber from './components/AuditoriaResumoContasPagarReceber'
import AuditoriaContasPagarReceberDetalhe from './components/AuditoriaContasPagarReceberDetalhe'
import AuditoriaResumoFornecedoresConciliacao from './components/AuditoriaResumoFornecedoresConciliacao'
import AuditoriaFornecedoresConciliacaoDetalhe from './components/AuditoriaFornecedoresConciliacaoDetalhe'
import AuditoriaResumoReceitasDiferidas from './components/AuditoriaResumoReceitasDiferidas'
import AuditoriaReceitasDiferidasDetalhe from './components/AuditoriaReceitasDiferidasDetalhe'
import AuditoriaResumoIntegridadeLancamentos from './components/AuditoriaResumoIntegridadeLancamentos'
import AuditoriaIntegridadeLancamentosDetalhe from './components/AuditoriaIntegridadeLancamentosDetalhe'
import AuditoriaResumoAdiantamentoSocios from './components/AuditoriaResumoAdiantamentoSocios'
import AuditoriaAdiantamentoSociosDetalhe from './components/AuditoriaAdiantamentoSociosDetalhe'
import AuditoriaResumoBeneficiosIndiretos from './components/AuditoriaResumoBeneficiosIndiretos'
import AuditoriaBeneficiosIndiretosDetalhe from './components/AuditoriaBeneficiosIndiretosDetalhe'
import AuditoriaResumoRastreabilidadeBancaria from './components/AuditoriaResumoRastreabilidadeBancaria'
import AuditoriaRastreabilidadeBancariaDetalhe from './components/AuditoriaRastreabilidadeBancariaDetalhe'
import AuditoriaResumoArredondamentosAjustes from './components/AuditoriaResumoArredondamentosAjustes'
import AuditoriaArredondamentosAjustesDetalhe from './components/AuditoriaArredondamentosAjustesDetalhe'
import AuditoriaResumoAdiantamentoFuncionarios from './components/AuditoriaResumoAdiantamentoFuncionarios'
import AuditoriaAdiantamentoFuncionariosDetalhe from './components/AuditoriaAdiantamentoFuncionariosDetalhe'
import AuditoriaResumoAdiantamentoSalario from './components/AuditoriaResumoAdiantamentoSalario'
import AuditoriaAdiantamentoSalarioDetalhe from './components/AuditoriaAdiantamentoSalarioDetalhe'
import AuditoriaResumoAnomaliaTarifaBancaria from './components/AuditoriaResumoAnomaliaTarifaBancaria'
import AuditoriaAnomaliaTarifaBancariaDetalhe from './components/AuditoriaAnomaliaTarifaBancariaDetalhe'
import AuditoriaResumoContaTransitoria from './components/AuditoriaResumoContaTransitoria'
import AuditoriaContaTransitoriaDetalhe from './components/AuditoriaContaTransitoriaDetalhe'
import AuditoriaResumoAdiantamentoViagem from './components/AuditoriaResumoAdiantamentoViagem'
import AuditoriaAdiantamentoViagemDetalhe from './components/AuditoriaAdiantamentoViagemDetalhe'
import AuditoriaResumoClassificacaoReceita from './components/AuditoriaResumoClassificacaoReceita'
import AuditoriaClassificacaoReceitaDetalhe from './components/AuditoriaClassificacaoReceitaDetalhe'
import AuditoriaResumoProvisaoPisCofins from './components/AuditoriaResumoProvisaoPisCofins'
import AuditoriaProvisaoPisCofinsDetalhe from './components/AuditoriaProvisaoPisCofinsDetalhe'
import AuditoriaResumoProvisaoIss from './components/AuditoriaResumoProvisaoIss'
import AuditoriaProvisaoIssDetalhe from './components/AuditoriaProvisaoIssDetalhe'
import AuditoriaResumoProvisaoIcms from './components/AuditoriaResumoProvisaoIcms'
import AuditoriaProvisaoIcmsDetalhe from './components/AuditoriaProvisaoIcmsDetalhe'
import AuditoriaResumoDuplicidadePagamentos from './components/AuditoriaResumoDuplicidadePagamentos'
import AuditoriaDuplicidadePagamentosDetalhe from './components/AuditoriaDuplicidadePagamentosDetalhe'
import AuditoriaResumoRotatividadeProvisoes from './components/AuditoriaResumoRotatividadeProvisoes'
import AuditoriaRotatividadeProvisoesDetalhe from './components/AuditoriaRotatividadeProvisoesDetalhe'
import AuditoriaResumoPddAnalitica from './components/AuditoriaResumoPddAnalitica'
import AuditoriaPddAnaliticaDetalhe from './components/AuditoriaPddAnaliticaDetalhe'
import AuditoriaResumoPejotizacao from './components/AuditoriaResumoPejotizacao'
import AuditoriaPejotizacaoDetalhe from './components/AuditoriaPejotizacaoDetalhe'
import AuditoriaResumoLancamentoManual from './components/AuditoriaResumoLancamentoManual'
import AuditoriaLancamentoManualDetalhe from './components/AuditoriaLancamentoManualDetalhe'
import AuditoriaResumoLancamentoEstorno from './components/AuditoriaResumoLancamentoEstorno'
import AuditoriaLancamentoEstornoDetalhe from './components/AuditoriaLancamentoEstornoDetalhe'
import AuditoriaResumoLancamentoDiaNaoUtil from './components/AuditoriaResumoLancamentoDiaNaoUtil'
import AuditoriaLancamentoDiaNaoUtilDetalhe from './components/AuditoriaLancamentoDiaNaoUtilDetalhe'
import AuditoriaResumoLancamentoCorretivo from './components/AuditoriaResumoLancamentoCorretivo'
import AuditoriaLancamentoCorretivoDetalhe from './components/AuditoriaLancamentoCorretivoDetalhe'
import AuditoriaResumoServicosTerceirosPf from './components/AuditoriaResumoServicosTerceirosPf'
import AuditoriaServicosTerceirosPfDetalhe from './components/AuditoriaServicosTerceirosPfDetalhe'
import AuditoriaResumoSocietaria from './components/AuditoriaResumoSocietaria'
import AuditoriaSocietariaDetalhe from './components/AuditoriaSocietariaDetalhe'
import AuditoriaResumoQualidadeHistoricos from './components/AuditoriaResumoQualidadeHistoricos'
import AuditoriaQualidadeHistoricosDetalhe from './components/AuditoriaQualidadeHistoricosDetalhe'
import AuditoriaResumoTransferPricing from './components/AuditoriaResumoTransferPricing'
import AuditoriaTransferPricingDetalhe from './components/AuditoriaTransferPricingDetalhe'
import AuditoriaResumoCambial from './components/AuditoriaResumoCambial'
import AuditoriaCambialDetalhe from './components/AuditoriaCambialDetalhe'
import AuditoriaResumoRoundTripping from './components/AuditoriaResumoRoundTripping'
import AuditoriaRoundTrippingDetalhe from './components/AuditoriaRoundTrippingDetalhe'
import AuditoriaResumoCashRich from './components/AuditoriaResumoCashRich'
import AuditoriaCashRichDetalhe from './components/AuditoriaCashRichDetalhe'
import AuditoriaResumoMutacaoVolatil from './components/AuditoriaResumoMutacaoVolatil'
import AuditoriaMutacaoVolatilDetalhe from './components/AuditoriaMutacaoVolatilDetalhe'
import AuditoriaResumoCreditoEstagnado from './components/AuditoriaResumoCreditoEstagnado'
import AuditoriaCreditoEstagnadoDetalhe from './components/AuditoriaCreditoEstagnadoDetalhe'
import AuditoriaResumoProvisaoEspelho from './components/AuditoriaResumoProvisaoEspelho'
import AuditoriaProvisaoEspelhoDetalhe from './components/AuditoriaProvisaoEspelhoDetalhe'
import AuditoriaResumoCorrelacaoReceita from './components/AuditoriaResumoCorrelacaoReceita'
import AuditoriaCorrelacaoReceitaDetalhe from './components/AuditoriaCorrelacaoReceitaDetalhe'
import AuditoriaResumoValorRedondo from './components/AuditoriaResumoValorRedondo'
import AuditoriaValorRedondoDetalhe from './components/AuditoriaValorRedondoDetalhe'
import AuditoriaResumoOutrasDespesas from './components/AuditoriaResumoOutrasDespesas'
import AuditoriaOutrasDespesasDetalhe from './components/AuditoriaOutrasDespesasDetalhe'
import AuditoriaResumoEstoqueSemMovimento from './components/AuditoriaResumoEstoqueSemMovimento'
import AuditoriaEstoqueSemMovimentoDetalhe from './components/AuditoriaEstoqueSemMovimentoDetalhe'
import AuditoriaResumoSplitDespesas from './components/AuditoriaResumoSplitDespesas'
import AuditoriaSplitDespesasDetalhe from './components/AuditoriaSplitDespesasDetalhe'
import AuditoriaResumoCaixaFornecedores from './components/AuditoriaResumoCaixaFornecedores'
import AuditoriaCaixaFornecedoresDetalhe from './components/AuditoriaCaixaFornecedoresDetalhe'
import AuditoriaResumoCircularidadeTransitoria from './components/AuditoriaResumoCircularidadeTransitoria'
import AuditoriaCircularidadeTransitoriaDetalhe from './components/AuditoriaCircularidadeTransitoriaDetalhe'
import AuditoriaResumoCorrelacaoFiscal from './components/AuditoriaResumoCorrelacaoFiscal'
import AuditoriaCorrelacaoFiscalDetalhe from './components/AuditoriaCorrelacaoFiscalDetalhe'
import AuditoriaResumoPlIntegridade from './components/AuditoriaResumoPlIntegridade'
import AuditoriaPlIntegridadeDetalhe from './components/AuditoriaPlIntegridadeDetalhe'
import AuditoriaResumoPayrollDrift from './components/AuditoriaResumoPayrollDrift'
import AuditoriaPayrollDriftDetalhe from './components/AuditoriaPayrollDriftDetalhe'
import AuditoriaResumoAssetRecovery from './components/AuditoriaResumoAssetRecovery'
import AuditoriaAssetRecoveryDetalhe from './components/AuditoriaAssetRecoveryDetalhe'
import AuditoriaResumoSimCapital from './components/AuditoriaResumoSimCapital'
import AuditoriaSimCapitalDetalhe from './components/AuditoriaSimCapitalDetalhe'
import AuditoriaResumoDespesaAnaliticaRelevante from './components/AuditoriaResumoDespesaAnaliticaRelevante'
import AuditoriaDespesaAnaliticaRelevanteDetalhe from './components/AuditoriaDespesaAnaliticaRelevanteDetalhe'

import {AuditoriaService} from './services/AuditoriaService'
import {AuditoriaBancariaService} from './services/AuditoriaBancariaService'
import {AuditoriaDepreciacaoService} from './services/AuditoriaDepreciacaoService'
import {AuditoriaCaixaService} from './services/AuditoriaCaixaService'
import {AuditoriaFinanceiraService} from './services/AuditoriaFinanceiraService'
import {AuditoriaZeramento13Service} from './services/AuditoriaZeramento13Service'
import {AuditoriaBaixaPatrimonialService} from './services/AuditoriaBaixaPatrimonialService'
import {AuditoriaAdiantamentoService} from './services/AuditoriaAdiantamentoService'
import {AuditoriaAdiantamentoClientesService} from './services/AuditoriaAdiantamentoClientesService'
import {AuditoriaDespesasAntecipadasService} from './services/AuditoriaDespesasAntecipadasService'
import {AuditoriaAjusteExerciciosAnterioresService} from './services/AuditoriaAjusteExerciciosAnterioresService'
import {AuditoriaContasPagarReceberService} from './services/AuditoriaContasPagarReceberService'
import {AuditoriaFornecedoresConciliacaoService} from './services/AuditoriaFornecedoresConciliacaoService'
import {AuditoriaReceitasDiferidasService} from './services/AuditoriaReceitasDiferidasService'
import {AuditoriaIntegridadeLancamentosService} from './services/AuditoriaIntegridadeLancamentosService'
import {AuditoriaAdiantamentoSociosService} from './services/AuditoriaAdiantamentoSociosService'
import {AuditoriaBeneficiosIndiretosService} from './services/AuditoriaBeneficiosIndiretosService'
import {AuditoriaRastreabilidadeBancariaService} from './services/AuditoriaRastreabilidadeBancariaService'
import {AuditoriaArredondamentosAjustesService} from './services/AuditoriaArredondamentosAjustesService'
import {AuditoriaAdiantamentoFuncionariosService} from './services/AuditoriaAdiantamentoFuncionariosService'
import {AuditoriaAdiantamentoSalarioService} from './services/AuditoriaAdiantamentoSalarioService'
import {AuditoriaAnomaliaTarifaBancariaService} from './services/AuditoriaAnomaliaTarifaBancariaService'
import {AuditoriaContaTransitoriaService} from './services/AuditoriaContaTransitoriaService'
import {AuditoriaAdiantamentoViagemService} from './services/AuditoriaAdiantamentoViagemService'
import {AuditoriaClassificacaoReceitaService} from './services/AuditoriaClassificacaoReceitaService'
import {AuditoriaProvisaoPisCofinsService} from './services/AuditoriaProvisaoPisCofinsService'
import {AuditoriaProvisaoIssService} from './services/AuditoriaProvisaoIssService'
import {AuditoriaProvisaoIcmsService} from './services/AuditoriaProvisaoIcmsService'
import {AuditoriaDuplicidadePagamentosService} from './services/AuditoriaDuplicidadePagamentosService'
import {AuditoriaRotatividadeProvisoesService} from './services/AuditoriaRotatividadeProvisoesService'
import {AuditoriaPddAnaliticaService} from './services/AuditoriaPddAnaliticaService'
import {AuditoriaPejotizacaoService} from './services/AuditoriaPejotizacaoService'
import {AuditoriaLancamentoManualService} from './services/AuditoriaLancamentoManualService'
import {AuditoriaLancamentoEstornoService} from './services/AuditoriaLancamentoEstornoService'
import {AuditoriaLancamentoDiaNaoUtilService} from './services/AuditoriaLancamentoDiaNaoUtilService'
import {AuditoriaDespesaAnaliticaRelevanteService} from './services/AuditoriaDespesaAnaliticaRelevanteService'
import {AuditoriaLancamentoCorretivoService} from './services/AuditoriaLancamentoCorretivoService'
import {AuditoriaServicosTerceirosPfService} from './services/AuditoriaServicosTerceirosPfService'
import {AuditoriaSocietariaService} from './services/AuditoriaSocietariaService'
import {AuditoriaQualidadeHistoricosService} from './services/AuditoriaQualidadeHistoricosService'
import {AuditoriaTransferPricingService} from './services/AuditoriaTransferPricingService'
import {AuditoriaCambialService} from './services/AuditoriaCambialService'
import {AuditoriaRoundTrippingService} from './services/AuditoriaRoundTrippingService'
import {AuditoriaCashRichService} from './services/AuditoriaCashRichService'
import {AuditoriaMutacaoVolatilService} from './services/AuditoriaMutacaoVolatilService'
import {AuditoriaCreditoEstagnadoService} from './services/AuditoriaCreditoEstagnadoService'
import {AuditoriaProvisaoEspelhoService} from './services/AuditoriaProvisaoEspelhoService'
import {AuditoriaCorrelacaoReceitaService} from './services/AuditoriaCorrelacaoReceitaService'
import {AuditoriaValorRedondoService} from './services/AuditoriaValorRedondoService'
import {AuditoriaOutrasDespesasService} from './services/AuditoriaOutrasDespesasService'
import {AuditoriaEstoqueSemMovimentoService} from './services/AuditoriaEstoqueSemMovimentoService'
import {AuditoriaSplitDespesasService} from './services/AuditoriaSplitDespesasService'
import {AuditoriaCaixaFornecedoresService} from './services/AuditoriaCaixaFornecedoresService'
import {AuditoriaCircularidadeTransitoriaService} from './services/AuditoriaCircularidadeTransitoriaService'
import {AuditoriaCorrelacaoFiscalService} from './services/AuditoriaCorrelacaoFiscalService'
import {AuditoriaPlIntegridadeService} from './services/AuditoriaPlIntegridadeService'
import {AuditoriaPayrollDriftService} from './services/AuditoriaPayrollDriftService'
import {AuditoriaAssetRecoveryService} from './services/AuditoriaAssetRecoveryService'
import {AuditoriaSimCapitalService} from './services/AuditoriaSimCapitalService'

import {
  IAuditoriaResultado,
  IEmpresaAuditoria,
  IPeriodoAuditoria,
  TributoAuditoria,
  TRIBUTOS_PERMITIDOS_TRIAL,
} from './interfaces/IAuditoria'
import {IAuditoriaBancariaResultado} from './interfaces/IAuditoriaBancaria'
import {IAuditoriaDepreciacaoResultado} from './interfaces/IAuditoriaDepreciacao'
import {IAuditoriaCaixaResultado} from './interfaces/IAuditoriaCaixa'
import {IAuditoriaFinanceiraResultado} from './interfaces/IAuditoriaFinanceira'
import {IAuditoriaZeramento13Resultado} from './interfaces/IAuditoriaZeramento13'
import {IAuditoriaBaixaPatrimonialResultado} from './interfaces/IAuditoriaBaixaPatrimonial'
import {IAuditoriaAdiantamentoResultado} from './interfaces/IAuditoriaAdiantamento'
import {IAuditoriaAdiantamentoClientesResultado} from './interfaces/IAuditoriaAdiantamentoClientes'
import {IAuditoriaDespesasAntecipadasResultado} from './interfaces/IAuditoriaDespesasAntecipadas'
import {IAuditoriaAjusteExerciciosAnterioresResultado} from './interfaces/IAuditoriaAjusteExerciciosAnteriores'
import {IAuditoriaContasPagarReceberResultado} from './interfaces/IAuditoriaContasPagarReceber'
import {IAuditoriaFornecedoresConciliacaoResultado} from './interfaces/IAuditoriaFornecedoresConciliacao'
import {IAuditoriaReceitasDiferidasResultado} from './interfaces/IAuditoriaReceitasDiferidas'
import {IAuditoriaIntegridadeLancamentosResultado} from './interfaces/IAuditoriaIntegridadeLancamentos'
import {IAuditoriaAdiantamentoSociosResultado} from './interfaces/IAuditoriaAdiantamentoSocios'
import {IAuditoriaBeneficiosIndiretosResultado} from './interfaces/IAuditoriaBeneficiosIndiretos'
import {IAuditoriaRastreabilidadeBancariaResultado} from './interfaces/IAuditoriaRastreabilidadeBancaria'
import {IAuditoriaArredondamentosAjustesResultado} from './interfaces/IAuditoriaArredondamentosAjustes'
import {IAuditoriaAdiantamentoFuncionariosResultado} from './interfaces/IAuditoriaAdiantamentoFuncionarios'
import {IAuditoriaAdiantamentoSalarioResultado} from './interfaces/IAuditoriaAdiantamentoSalario'
import {IAuditoriaAnomaliaTarifaBancariaResultado} from './interfaces/IAuditoriaAnomaliaTarifaBancaria'
import {IAuditoriaContaTransitoriaResultado} from './interfaces/IAuditoriaContaTransitoria'
import {IAuditoriaAdiantamentoViagemResultado} from './interfaces/IAuditoriaAdiantamentoViagem'
import {IAuditoriaClassificacaoReceitaResultado} from './interfaces/IAuditoriaClassificacaoReceita'
import {IAuditoriaProvisaoPisCofinsResultado} from './interfaces/IAuditoriaProvisaoPisCofins'
import {IAuditoriaProvisaoIssResultado} from './interfaces/IAuditoriaProvisaoIss'
import {IAuditoriaProvisaoIcmsResultado} from './interfaces/IAuditoriaProvisaoIcms'
import {IAuditoriaDuplicidadePagamentosResultado} from './interfaces/IAuditoriaDuplicidadePagamentos'
import {IAuditoriaRotatividadeProvisoesResultado} from './interfaces/IAuditoriaRotatividadeProvisoes'
import {IAuditoriaPddAnaliticaResultado} from './interfaces/IAuditoriaPddAnalitica'
import {IAuditoriaPejotizacaoResultado} from './interfaces/IAuditoriaPejotizacao'
import {IAuditoriaLancamentoManualResultado} from './interfaces/IAuditoriaLancamentoManual'
import {IAuditoriaLancamentoEstornoResultado} from './interfaces/IAuditoriaLancamentoEstorno'
import {IAuditoriaLancamentoDiaNaoUtilResultado} from './interfaces/IAuditoriaLancamentoDiaNaoUtil'
import {IAuditoriaDespesaAnaliticaRelevanteResultado} from './interfaces/IAuditoriaDespesaAnaliticaRelevante'
import {IAuditoriaLancamentoCorretivoResultado} from './interfaces/IAuditoriaLancamentoCorretivo'
import {IAuditoriaServicosTerceirosPfResultado} from './interfaces/IAuditoriaServicosTerceirosPf'
import {IAuditoriaSocietariaResultado} from './interfaces/IAuditoriaSocietaria'
import {IAuditoriaQualidadeHistoricosResultado} from './interfaces/IAuditoriaQualidadeHistoricos'
import {IAuditoriaTransferPricingResultado} from './interfaces/IAuditoriaTransferPricing'
import {IAuditoriaCambialResultado} from './interfaces/IAuditoriaCambial'
import {IAuditoriaRoundTrippingResultado} from './interfaces/IAuditoriaRoundTripping'
import {IAuditoriaCashRichResultado} from './interfaces/IAuditoriaCashRich'
import {IAuditoriaMutacaoVolatilResultado} from './interfaces/IAuditoriaMutacaoVolatil'
import {IAuditoriaCreditoEstagnadoResultado} from './interfaces/IAuditoriaCreditoEstagnado'
import {IAuditoriaProvisaoEspelhoResultado} from './interfaces/IAuditoriaProvisaoEspelho'
import {IAuditoriaCorrelacaoReceitaResultado} from './interfaces/IAuditoriaCorrelacaoReceita'
import {IAuditoriaValorRedondoResultado} from './interfaces/IAuditoriaValorRedondo'
import {IAuditoriaOutrasDespesasResultado} from './interfaces/IAuditoriaOutrasDespesas'
import {IAuditoriaEstoqueSemMovimentoResultado} from './interfaces/IAuditoriaEstoqueSemMovimento'
import {IAuditoriaSplitDespesasResultado} from './interfaces/IAuditoriaSplitDespesas'
import {IAuditoriaCaixaFornecedoresResultado} from './interfaces/IAuditoriaCaixaFornecedores'
import {IAuditoriaCircularidadeTransitoriaResultado} from './interfaces/IAuditoriaCircularidadeTransitoria'
import {IAuditoriaCorrelacaoFiscalResultado} from './interfaces/IAuditoriaCorrelacaoFiscal'
import {IAuditoriaPlIntegridadeResultado} from './interfaces/IAuditoriaPlIntegridade'
import {IAuditoriaPayrollDriftResultado} from './interfaces/IAuditoriaPayrollDrift'
import {IAuditoriaAssetRecoveryResultado} from './interfaces/IAuditoriaAssetRecovery'
import {IAuditoriaSimCapitalResultado} from './interfaces/IAuditoriaSimCapital'
import {executarComLimiteDeConcorrencia} from './utils/concorrencia'

import {LaudoAuditoriaService} from './services/LaudoAuditoriaService'
import {ILaudoAuditoria} from './interfaces/ILaudoAuditoria'
import AuditoriaLaudoBarraProgressao from './components/AuditoriaLaudoBarraProgressao'
import AuditoriaCircularizacaoBarraProgressao from './circularizacao/components/AuditoriaCircularizacaoBarraProgressao'
import {categoriaParaSlug} from './circularizacao/utils/categoriaSlug'
import {exportarLaudoEBaixar} from './utils/exportarLaudo'

const AuditoriaPage: React.FC = () => {
  const history = useHistory()
  const location = useLocation()
  // DEVN3-521 — voltando de /auditoria/revisao (?empresa=&periodo=), a seleção é reaplicada
  // uma única vez, conforme as listas de empresas e períodos carregam.
  const selecaoInicial = React.useRef<{empresa?: number; periodo?: string} | undefined>(
    (() => {
      const params = new URLSearchParams(location.search)
      const empresa = Number(params.get('empresa'))
      return empresa > 0 ? {empresa, periodo: params.get('periodo') ?? undefined} : undefined
    })()
  )

  const [tier, setTier] = useState<TipoAcessoAuditoria | null>(null)
  const [tierCarregando, setTierCarregando] = useState(true)

  const [empresas, setEmpresas] = useState<IEmpresaAuditoria[]>([])
  const [periodos, setPeriodos] = useState<IPeriodoAuditoria[]>([])

  const [empresaId, setEmpresaId] = useState<number | undefined>()
  const [periodo, setPeriodo] = useState<string | undefined>()
  // COR-191: começa vazio (nenhum tributo pré-selecionado) — o usuário escolhe explicitamente
  // "TODOS" ou um módulo individual antes de qualquer carregamento começar. Antes, "TODOS" vinha
  // pré-selecionado e disparava o carregamento das ~59 chamadas assim que empresa+período eram
  // escolhidos, sem o usuário ter pedido isso.
  const [tributo, setTributo] = useState<TributoAuditoria | ''>('')

  const [loading, setLoading] = useState(false)
  const [erro, setErro] = useState<string>()

  // DEVN3-521 — Laudo de Auditoria (Motor Narrativo Universal). Gerado 1x em background na 1ª
  // seleção de empresa+período; a barra de progressão fica no sidebar e a revisão acontece em
  // /auditoria/revisao.
  const [laudo, setLaudo] = useState<ILaudoAuditoria | null>(null)
  const [exportandoLaudo, setExportandoLaudo] = useState(false)
  // COR-185: alimenta o cockpit da aba TODOS (gauges "Progresso da Auditoria" e "Módulos Pendentes").
  const [falhasCarregamento, setFalhasCarregamento] = useState<string[]>([])
  const [totalModulosTentados, setTotalModulosTentados] = useState(0)

  const [resultado, setResultado] = useState<IAuditoriaResultado>({cards: [], empresas: []})
  const [resultadoBancario, setResultadoBancario] = useState<IAuditoriaBancariaResultado>({
    totalDisponibilidadesAnalisadas: 0,
    totalDepositosBancarios: 0,
    totalAplicacoesLiquidezImediata: 0,
    possuiAplicacoesLiquidezImediata: false,
    penalidadePrevisivelTotal: 0,
    impactoFinanceiroTotal: 0,
    totalAvisos: 0,
    totalAlertas: 0,
    totalErros: 0,
    status: 'CONCILIADO',
    mensagemDirecionamento: '',
    contas: [],
  })
  const [resultadoDepreciacao, setResultadoDepreciacao] = useState<IAuditoriaDepreciacaoResultado>({
    exposicaoContabilTotal: 0,
    impactoFinanceiroTotal: 0,
    totalOcorrencias: 0,
    totalAvisos: 0,
    totalAlertas: 0,
    totalErros: 0,
    status: 'CONCILIADO',
    mensagemDirecionamento: '',
    fundamentacaoContabil: '',
    fundamentacaoTributaria: '',
    fundamentacaoContabilResumo: '',
    fundamentacaoTributariaResumo: '',
    fundamentacaoContabilLinks: [],
    fundamentacaoTributariaLinks: [],
    itens: [],
  })
  const [resultadoCaixa, setResultadoCaixa] = useState<IAuditoriaCaixaResultado>({
    impactoFiscalTotal: 0,
    impactoFinanceiroTotal: 0,
    totalAvisos: 0,
    totalAlertas: 0,
    totalErros: 0,
    status: 'CONCILIADO',
    mensagemDirecionamento: '',
    fundamentacaoSaldoCredor: '',
    fundamentacaoEspecie: '',
    fundamentacaoBeneficioIndireto: '',
    saldoCredor: [],
    operacoesEspecie: [],
    beneficioIndireto: [],
  })
  const [resultadoFinanceira, setResultadoFinanceira] = useState<IAuditoriaFinanceiraResultado>({
    impactoFiscalTotal: 0,
    impactoFinanceiroTotal: 0,
    creditoTributarioPerdidoTotal: 0,
    totalAvisos: 0,
    totalAlertas: 0,
    totalErros: 0,
    totalPendentes: 0,
    status: 'CONCILIADO',
    mensagemDirecionamento: '',
    fundamentacaoResgateIrrf: '',
    fundamentacaoResgateIof: '',
    fundamentacaoReceitaMensal: '',
    fundamentacaoConciliacao: '',
    resgatesSemIrrf: [],
    resgatesSemIof: [],
    receitaMensalAusente: [],
    conciliacaoConsolidada: [],
  })
  const [resultadoZeramento13, setResultadoZeramento13] = useState<IAuditoriaZeramento13Resultado>({
    impactoFiscalTotal: 0,
    impactoFinanceiroTotal: 0,
    totalAvisos: 0,
    totalAlertas: 0,
    totalErros: 0,
    status: 'CONCILIADO',
    mensagemDirecionamento: '',
    fundamentacaoSaldoFinal: '',
    fundamentacaoSaldoInicial: '',
    fundamentacaoProvisaoMensal: '',
    saldoFinalNaoZerado: [],
    saldoInicialNaoZerado: [],
    provisaoMensalAusente: [],
    contasConciliadas: [],
  })
  const [resultadoBaixaPatrimonial, setResultadoBaixaPatrimonial] =
    useState<IAuditoriaBaixaPatrimonialResultado>({
      impactoFiscalTotal: 0,
      impactoFinanceiroTotal: 0,
      totalAvisos: 0,
      totalAlertas: 0,
      totalErros: 0,
      status: 'CONCILIADO',
      mensagemDirecionamento: '',
      fundamentacaoContrapartida: '',
      fundamentacaoRastreabilidade: '',
      baixasSemContrapartida: [],
      baixasSemIdentificacao: [],
      baixasPossiveisAlienacoes: [],
      baixasConciliadas: [],
      baixasReclassificacaoPendenteJustificativa: [],
    })
  const [resultadoAdiantamento, setResultadoAdiantamento] =
    useState<IAuditoriaAdiantamentoResultado>({
      impactoFiscalTotal: 0,
      impactoFinanceiroTotal: 0,
      totalAvisos: 0,
      totalAlertas: 0,
      totalPendentes: 0,
      totalErros: 0,
      status: 'CONCILIADO',
      mensagemDirecionamento: '',
      fundamentacaoEstagnacao: '',
      adiantamentosEstagnados: [],
      adiantamentosConciliados: [],
    })
  const [resultadoAdiantamentoClientes, setResultadoAdiantamentoClientes] =
    useState<IAuditoriaAdiantamentoClientesResultado>({
      impactoFiscalTotal: 0,
      impactoFinanceiroTotal: 0,
      totalAvisos: 0,
      totalAlertas: 0,
      totalErros: 0,
      status: 'CONCILIADO',
      mensagemDirecionamento: '',
      fundamentacaoEstagnacao: '',
      adiantamentosEstagnados: [],
      adiantamentosConciliados: [],
    })
  const [resultadoDespesasAntecipadas, setResultadoDespesasAntecipadas] =
    useState<IAuditoriaDespesasAntecipadasResultado>({
      impactoFiscalTotal: 0,
      impactoFinanceiroTotal: 0,
      totalAvisos: 0,
      totalAlertas: 0,
      totalErros: 0,
      status: 'CONCILIADO',
      mensagemDirecionamento: '',
      fundamentacaoEstagnacao: '',
      fundamentacaoQuebraCompetenciaFiscal: '',
      fundamentacaoQuebraCompetenciaContabil: '',
      despesasEstagnadas: [],
      despesasConciliadas: [],
      quebraCompetenciaMensal: [],
    })
  const [resultadoAjusteExerciciosAnteriores, setResultadoAjusteExerciciosAnteriores] =
    useState<IAuditoriaAjusteExerciciosAnterioresResultado>({
      impactoFiscalTotal: 0,
      impactoFinanceiroTotal: 0,
      totalAvisos: 0,
      totalAlertas: 0,
      totalErros: 0,
      status: 'CONCILIADO',
      mensagemDirecionamento: '',
      fundamentacaoMovimentacao: '',
      movimentacoesIndevidas: [],
      contasConciliadas: [],
    })
  const [resultadoContasPagarReceber, setResultadoContasPagarReceber] =
    useState<IAuditoriaContasPagarReceberResultado>({
      impactoFiscalTotal: 0,
      impactoFinanceiroTotal: 0,
      totalAvisos: 0,
      totalAlertas: 0,
      totalErros: 0,
      status: 'CONCILIADO',
      mensagemDirecionamento: '',
      fundamentacaoNaturezaInvertida: '',
      contasComNaturezaInvertida: [],
      contasConciliadas: [],
    })
  const [resultadoFornecedoresConciliacao, setResultadoFornecedoresConciliacao] =
    useState<IAuditoriaFornecedoresConciliacaoResultado>({
      impactoFiscalTotal: 0,
      impactoFinanceiroTotal: 0,
      totalAvisos: 0,
      totalAlertas: 0,
      totalErros: 0,
      status: 'CONCILIADO',
      mensagemDirecionamento: '',
      fundamentacaoClassificacaoReferencial: '',
      fornecedoresPendentesClassificacao: [],
      fornecedoresConciliados: [],
    })
  const [resultadoReceitasDiferidas, setResultadoReceitasDiferidas] =
    useState<IAuditoriaReceitasDiferidasResultado>({
      impactoFiscalTotal: 0,
      impactoFinanceiroTotal: 0,
      totalAvisos: 0,
      totalAlertas: 0,
      totalErros: 0,
      status: 'CONCILIADO',
      mensagemDirecionamento: '',
      fundamentacaoSegregacao: '',
      receitasDiferidasPendentes: [],
      receitasDiferidasConciliadas: [],
    })
  const [resultadoIntegridadeLancamentos, setResultadoIntegridadeLancamentos] =
    useState<IAuditoriaIntegridadeLancamentosResultado>({
      impactoFiscalTotal: 0,
      impactoFinanceiroTotal: 0,
      totalAvisos: 0,
      totalAlertas: 0,
      totalErros: 0,
      totalLancamentosAnalisados: 0,
      status: 'CONCILIADO',
      mensagemDirecionamento: '',
      fundamentacaoIntegridade: '',
      lancamentosGenericos: [],
    })
  const [resultadoAdiantamentoSocios, setResultadoAdiantamentoSocios] =
    useState<IAuditoriaAdiantamentoSociosResultado>({
      impactoFiscalTotal: 0,
      impactoFinanceiroTotal: 0,
      totalAvisos: 0,
      totalAlertas: 0,
      totalErros: 0,
      status: 'CONCILIADO',
      mensagemDirecionamento: '',
      fundamentacaoCaracterizacaoRemuneracao: '',
      adiantamentosSemLastro: [],
      adiantamentosConciliados: [],
    })
  const [resultadoBeneficiosIndiretos, setResultadoBeneficiosIndiretos] =
    useState<IAuditoriaBeneficiosIndiretosResultado>({
      impactoFiscalTotal: 0,
      impactoFinanceiroTotal: 0,
      totalAvisos: 0,
      totalAlertas: 0,
      totalErros: 0,
      status: 'CONCILIADO',
      mensagemDirecionamento: '',
      fundamentacaoBeneficioIndireto: '',
      qsaDisponivel: false,
      mensagemQsa: '',
      despesasIndevidas: [],
      proLaboreConciliado: [],
    })
  const [resultadoRastreabilidadeBancaria, setResultadoRastreabilidadeBancaria] =
    useState<IAuditoriaRastreabilidadeBancariaResultado>({
      impactoFiscalTotal: 0,
      impactoFinanceiroTotal: 0,
      totalAvisos: 0,
      totalAlertas: 0,
      totalErros: 0,
      status: 'CONCILIADO',
      mensagemDirecionamento: '',
      fundamentacaoContabil: '',
      fundamentacaoFiscal: '',
      errosRastreabilidade: [],
      contasConciliadas: [],
      divergenciasReferencial: [],
      parametrosAplicados: {
        modoValidacao: 'RsEDoc',
        descricaoModo: '',
        contasExcluidas: [],
        configuracaoPersonalizada: false,
        participanteExigido: true,
        documentoExigido: true,
      },
    })
  const [resultadoArredondamentosAjustes, setResultadoArredondamentosAjustes] =
    useState<IAuditoriaArredondamentosAjustesResultado>({
      impactoFiscalTotal: 0,
      impactoFinanceiroTotal: 0,
      totalAvisos: 0,
      totalAlertas: 0,
      totalErros: 0,
      totalLancamentosAnalisados: 0,
      status: 'CONCILIADO',
      mensagemDirecionamento: '',
      fundamentacaoFiscal: '',
      fundamentacaoContabil: '',
      lancamentosAjuste: [],
    })
  const [resultadoAdiantamentoFuncionarios, setResultadoAdiantamentoFuncionarios] =
    useState<IAuditoriaAdiantamentoFuncionariosResultado>({
      impactoFiscalTotal: 0,
      impactoFinanceiroTotal: 0,
      totalAvisos: 0,
      totalAlertas: 0,
      totalErros: 0,
      status: 'CONCILIADO',
      mensagemDirecionamento: '',
      fundamentacaoFiscal: '',
      fundamentacaoContabil: '',
      adiantamentosEstagnados: [],
      adiantamentosConciliados: [],
      contasDivergenciaReferencial: [],
    })
  const [resultadoAdiantamentoSalario, setResultadoAdiantamentoSalario] =
    useState<IAuditoriaAdiantamentoSalarioResultado>({
      impactoFiscalTotal: 0,
      impactoFinanceiroTotal: 0,
      totalAvisos: 0,
      totalAlertas: 0,
      totalErros: 0,
      status: 'CONCILIADO',
      mensagemDirecionamento: '',
      fundamentacaoFiscal: '',
      fundamentacaoContabil: '',
      adiantamentosPendentes: [],
      adiantamentosConciliados: [],
    })
  const [resultadoAnomaliaTarifaBancaria, setResultadoAnomaliaTarifaBancaria] =
    useState<IAuditoriaAnomaliaTarifaBancariaResultado>({
      impactoFiscalTotal: 0,
      impactoFinanceiroTotal: 0,
      totalAvisos: 0,
      totalAlertas: 0,
      totalErros: 0,
      status: 'CONCILIADO',
      mensagemDirecionamento: '',
      fundamentacaoFiscal: '',
      fundamentacaoContabil: '',
      anomaliasDetectadas: [],
      tarifasRegulares: [],
    })
  const [resultadoContaTransitoria, setResultadoContaTransitoria] =
    useState<IAuditoriaContaTransitoriaResultado>({
      impactoFiscalTotal: 0,
      impactoFinanceiroTotal: 0,
      totalAvisos: 0,
      totalAlertas: 0,
      totalErros: 0,
      status: 'CONCILIADO',
      mensagemDirecionamento: '',
      fundamentacaoFiscal: '',
      fundamentacaoContabil: '',
      saldoNaoZerado: [],
      contasConciliadas: [],
    })
  const [resultadoAdiantamentoViagem, setResultadoAdiantamentoViagem] =
    useState<IAuditoriaAdiantamentoViagemResultado>({
      impactoFiscalTotal: 0,
      impactoFinanceiroTotal: 0,
      totalAvisos: 0,
      totalAlertas: 0,
      totalErros: 0,
      status: 'CONCILIADO',
      mensagemDirecionamento: '',
      fundamentacaoFiscal: '',
      fundamentacaoContabil: '',
      adiantamentosPendentes: [],
      adiantamentosConciliados: [],
    })
  const [resultadoClassificacaoReceita, setResultadoClassificacaoReceita] =
    useState<IAuditoriaClassificacaoReceitaResultado>({
      impactoFiscalTotal: 0,
      impactoFinanceiroTotal: 0,
      totalAvisos: 0,
      totalAlertas: 0,
      totalErros: 0,
      status: 'CONCILIADO',
      mensagemDirecionamento: '',
      fundamentacaoFiscal: '',
      fundamentacaoContabil: '',
      classificacoesIndevidas: [],
      contasConciliadas: [],
      contasSemReferencial: [],
      contasRedutoras: [],
    })
  const [resultadoProvisaoPisCofins, setResultadoProvisaoPisCofins] =
    useState<IAuditoriaProvisaoPisCofinsResultado>({
      impactoFiscalTotal: 0,
      impactoFinanceiroTotal: 0,
      totalAvisos: 0,
      totalAlertas: 0,
      totalErros: 0,
      status: 'CONCILIADO',
      mensagemDirecionamento: '',
      fundamentacaoFiscal: '',
      fundamentacaoContabil: '',
      provisoesAusentes: [],
      mesesConciliados: [],
    })
  const [resultadoProvisaoIss, setResultadoProvisaoIss] = useState<IAuditoriaProvisaoIssResultado>({
    impactoFiscalTotal: 0,
    impactoFinanceiroTotal: 0,
    totalAvisos: 0,
    totalAlertas: 0,
    totalErros: 0,
    status: 'CONCILIADO',
    mensagemDirecionamento: '',
    fundamentacaoFiscal: '',
    fundamentacaoContabil: '',
    provisoesAusentes: [],
    mesesConciliados: [],
  })
  const [resultadoProvisaoIcms, setResultadoProvisaoIcms] =
    useState<IAuditoriaProvisaoIcmsResultado>({
      impactoFiscalTotal: 0,
      impactoFinanceiroTotal: 0,
      totalAvisos: 0,
      totalAlertas: 0,
      totalErros: 0,
      status: 'CONCILIADO',
      mensagemDirecionamento: '',
      fundamentacaoFiscal: '',
      fundamentacaoContabil: '',
      anomaliasDetectadas: [],
      mesesConciliados: [],
    })
  const [resultadoDuplicidadePagamentos, setResultadoDuplicidadePagamentos] =
    useState<IAuditoriaDuplicidadePagamentosResultado>({
      impactoFinanceiroTotal: 0,
      totalAvisos: 0,
      totalAlertas: 0,
      totalErros: 0,
      totalLancamentosAnalisados: 0,
      status: 'CONCILIADO',
      mensagemDirecionamento: '',
      fundamentacaoContabil: '',
      fundamentacaoFiscal: '',
      duplicidades: [],
    })
  const [resultadoRotatividadeProvisoes, setResultadoRotatividadeProvisoes] =
    useState<IAuditoriaRotatividadeProvisoesResultado>({
      impactoFiscalTotal: 0,
      impactoFinanceiroTotal: 0,
      totalAvisos: 0,
      totalAlertas: 0,
      totalErros: 0,
      status: 'CONCILIADO',
      mensagemDirecionamento: '',
      fundamentacaoContabil: '',
      fundamentacaoFiscal: '',
      provisoesPendentes: [],
      provisoesConciliadas: [],
    })
  const [resultadoPddAnalitica, setResultadoPddAnalitica] =
    useState<IAuditoriaPddAnaliticaResultado>({
      impactoFiscalTotal: 0,
      impactoFinanceiroTotal: 0,
      totalAvisos: 0,
      totalAlertas: 0,
      totalErros: 0,
      status: 'CONCILIADO',
      mensagemDirecionamento: '',
      fundamentacaoContabil: '',
      fundamentacaoFiscal: '',
      saldosPendentes: [],
      saldosConciliados: [],
    })
  const [resultadoPejotizacao, setResultadoPejotizacao] = useState<IAuditoriaPejotizacaoResultado>({
    impactoFiscalTotal: 0,
    impactoFinanceiroTotal: 0,
    totalAvisos: 0,
    totalAlertas: 0,
    totalErros: 0,
    status: 'CONCILIADO',
    mensagemDirecionamento: '',
    fundamentacaoLegal: '',
    qsaDisponivel: false,
    mensagemQsa: '',
    fornecedoresRecorrentes: [],
    fornecedoresConciliados: [],
  })
  const [resultadoLancamentoManual, setResultadoLancamentoManual] =
    useState<IAuditoriaLancamentoManualResultado>({
      impactoFiscalTotal: 0,
      impactoFinanceiroTotal: 0,
      totalAvisos: 0,
      totalAlertas: 0,
      totalErros: 0,
      totalLancamentosAnalisados: 0,
      status: 'CONCILIADO',
      mensagemDirecionamento: '',
      fundamentacaoContabil: '',
      lancamentosManuais: [],
    })
  const [resultadoLancamentoEstorno, setResultadoLancamentoEstorno] =
    useState<IAuditoriaLancamentoEstornoResultado>({
      impactoFiscalTotal: 0,
      impactoFinanceiroTotal: 0,
      totalAvisos: 0,
      totalAlertas: 0,
      totalErros: 0,
      totalLancamentosAnalisados: 0,
      status: 'CONCILIADO',
      mensagemDirecionamento: '',
      fundamentacaoContabil: '',
      lancamentosEstorno: [],
    })
  const [resultadoLancamentoDiaNaoUtil, setResultadoLancamentoDiaNaoUtil] =
    useState<IAuditoriaLancamentoDiaNaoUtilResultado>({
      impactoFiscalTotal: 0,
      impactoFinanceiroTotal: 0,
      totalAvisos: 0,
      totalAvisosTecnicos: 0,
      totalAlertas: 0,
      totalErros: 0,
      totalLancamentosAnalisados: 0,
      status: 'CONCILIADO',
      mensagemDirecionamento: '',
      fundamentacaoContabil: '',
      lancamentosDiaNaoUtil: [],
    })
  const [resultadoDespesaAnaliticaRelevante, setResultadoDespesaAnaliticaRelevante] =
    useState<IAuditoriaDespesaAnaliticaRelevanteResultado>({
      impactoFiscalTotal: 0,
      impactoFinanceiroTotal: 0,
      totalAvisos: 0,
      totalAlertas: 0,
      totalErros: 0,
      totalLancamentosAnalisados: 0,
      status: 'CONCILIADO',
      mensagemDirecionamento: '',
      fundamentacaoContabil: '',
      fundamentacaoFiscal: '',
      lancamentosDespesaRelevante: [],
    })
  const [resultadoLancamentoCorretivo, setResultadoLancamentoCorretivo] =
    useState<IAuditoriaLancamentoCorretivoResultado>({
      impactoFiscalTotal: 0,
      impactoFinanceiroTotal: 0,
      totalAvisos: 0,
      totalAlertas: 0,
      totalErros: 0,
      totalLancamentosAnalisados: 0,
      status: 'CONCILIADO',
      mensagemDirecionamento: '',
      fundamentacaoContabil: '',
      orientacaoJustificativa: '',
      lancamentosCorretivos: [],
    })
  const [resultadoServicosTerceirosPf, setResultadoServicosTerceirosPf] =
    useState<IAuditoriaServicosTerceirosPfResultado>({
      impactoFiscalTotal: 0,
      impactoFinanceiroTotal: 0,
      totalAvisos: 0,
      totalAlertas: 0,
      totalErros: 0,
      totalPendentes: 0,
      totalDescartados: 0,
      totalLancamentosAnalisados: 0,
      status: 'CONCILIADO',
      mensagemDirecionamento: '',
      fundamentacaoContabil: '',
      fundamentacaoFiscal: '',
      orientacaoJustificativa: '',
      lancamentosServicosTerceirosPf: [],
    })
  const [resultadoSocietaria, setResultadoSocietaria] = useState<IAuditoriaSocietariaResultado>({
    impactoFiscalTotal: 0,
    totalErros: 0,
    totalAlertas: 0,
    totalAvisos: 0,
    status: 'CONCILIADO',
    mensagemDirecionamento: '',
    fundamentacaoLegal: '',
    capitalSocial: [],
  })
  const [resultadoQualidadeHistoricos, setResultadoQualidadeHistoricos] =
    useState<IAuditoriaQualidadeHistoricosResultado>({
      impactoFiscalTotal: 0,
      totalErros: 0,
      totalAlertas: 0,
      totalAvisos: 0,
      totalPendentes: 0,
      totalReferencialDivergente: 0,
      totalLinhasAnalisadas: 0,
      totalLinhasComErro: 0,
      totalLinhasQualificadas: 0,
      totalLinhasSemMulta: 0,
      status: 'CONCILIADO',
      mensagemDirecionamento: '',
      fundamentacaoLegal: '',
      contas: [],
    })
  // DEVN3-593: true enquanto a API responde 202 (auditoria de empresa grande sendo processada).
  const [qualidadeProcessando, setQualidadeProcessando] = useState(false)
  const [resultadoTransferPricing, setResultadoTransferPricing] =
    useState<IAuditoriaTransferPricingResultado>({
      exposicaoFinanceiraTotalGeral: 0,
      passivoTributarioPrincipalTotal: 0,
      multaQualificadaTotal: 0,
      multaAcessoriaTotal: 0,
      impactoFiscalTotal: 0,
      totalErros: 0,
      totalAlertas: 0,
      totalAvisos: 0,
      status: 'CONCILIADO',
      mensagemDirecionamento: '',
      fundamentacaoLegal: '',
      itens: [],
    })
  const [resultadoCambial, setResultadoCambial] = useState<IAuditoriaCambialResultado>({
    exposicaoFiscalTotalGeral: 0,
    passivoFiscalTotal: 0,
    multaQualificadaTotal: 0,
    multaAcessoriaTotal: 0,
    totalErros: 0,
    totalAlertas: 0,
    totalAvisos: 0,
    status: 'CONCILIADO',
    mensagemDirecionamento: '',
    fundamentacaoLegal: '',
    itens: [],
  })
  const [resultadoRoundTripping, setResultadoRoundTripping] =
    useState<IAuditoriaRoundTrippingResultado>({
      passivoTotalGeral: 0,
      tributoPrincipalTotal: 0,
      multaQualificadaTotal: 0,
      jurosSelicTotal: 0,
      totalErros: 0,
      totalAlertas: 0,
      totalAvisos: 0,
      status: 'CONCILIADO',
      mensagemDirecionamento: '',
      fundamentacaoLegal: '',
      itens: [],
    })
  const [resultadoCashRich, setResultadoCashRich] = useState<IAuditoriaCashRichResultado>({
    impactoFinanceiroTotal: 0,
    impactoFiscalTotal: 0,
    totalErros: 0,
    totalAlertas: 0,
    totalAvisos: 0,
    status: 'CONCILIADO',
    mensagemDirecionamento: '',
    fundamentacaoLegal: '',
    itens: [],
  })
  const [resultadoMutacaoVolatil, setResultadoMutacaoVolatil] =
    useState<IAuditoriaMutacaoVolatilResultado>({
      exposicaoTotalGeral: 0,
      passivoTributarioTotal: 0,
      multaQualificadaTotal: 0,
      jurosSelicTotal: 0,
      totalErros: 0,
      totalAlertas: 0,
      totalAvisos: 0,
      status: 'CONCILIADO',
      mensagemDirecionamento: '',
      fundamentacaoLegal: '',
      itens: [],
    })
  const [resultadoCreditoEstagnado, setResultadoCreditoEstagnado] =
    useState<IAuditoriaCreditoEstagnadoResultado>({
      itens: [],
      totalErros: 0,
      totalAlertas: 0,
      totalAvisos: 0,
      perdaSelicTotal: 0,
      status: 'CONCILIADO',
      mensagemDirecionamento: '',
      fundamentacaoLegal: '',
    })
  const [resultadoProvisaoEspelho, setResultadoProvisaoEspelho] =
    useState<IAuditoriaProvisaoEspelhoResultado>({
      itens: [],
      totalErros: 0,
      totalAlertas: 0,
      totalAvisos: 0,
      passivoTributarioTotal: 0,
      status: 'CONCILIADO',
      mensagemDirecionamento: '',
      fundamentacaoLegal: '',
    })
  const [resultadoCorrelacaoReceita, setResultadoCorrelacaoReceita] =
    useState<IAuditoriaCorrelacaoReceitaResultado>({
      itens: [],
      totalErros: 0,
      totalAlertas: 0,
      totalAvisos: 0,
      passivoTributarioTotal: 0,
      status: 'CONCILIADO',
      mensagemDirecionamento: '',
      fundamentacaoLegal: '',
    })
  const [resultadoValorRedondo, setResultadoValorRedondo] =
    useState<IAuditoriaValorRedondoResultado>({
      itens: [],
      totalErros: 0,
      totalAlertas: 0,
      totalAvisos: 0,
      passivoTributarioTotal: 0,
      status: 'CONCILIADO',
      mensagemDirecionamento: '',
      fundamentacaoLegal: '',
    })
  const [resultadoOutrasDespesas, setResultadoOutrasDespesas] =
    useState<IAuditoriaOutrasDespesasResultado>({
      itens: [],
      totalErros: 0,
      totalAlertas: 0,
      totalAvisos: 0,
      passivoTributarioTotal: 0,
      status: 'CONCILIADO',
      mensagemDirecionamento: '',
      fundamentacaoLegal: '',
    })
  const [resultadoEstoqueSemMovimento, setResultadoEstoqueSemMovimento] =
    useState<IAuditoriaEstoqueSemMovimentoResultado>({
      itens: [],
      totalErros: 0,
      totalAlertas: 0,
      totalAvisos: 0,
      passivoTributarioTotal: 0,
      status: 'CONCILIADO',
      mensagemDirecionamento: '',
      fundamentacaoLegal: '',
      quantidadeContasLocalizadas: 0,
      contasAnalisadas: [],
    })
  const [resultadoSplitDespesas, setResultadoSplitDespesas] =
    useState<IAuditoriaSplitDespesasResultado>({
      grupos: [],
      totalErros: 0,
      totalAlertas: 0,
      totalAvisos: 0,
      passivoTributarioTotal: 0,
      status: 'CONCILIADO',
      mensagemDirecionamento: '',
      fundamentacaoLegal: '',
      quantidadeContasAnalisadas: 0,
      quantidadeLancamentosAnalisados: 0,
      referenciaisConsiderados: [],
      criteriosAnalise: '',
      contasAnalisadas: [],
      contasIgnoradas: [],
    })
  const [resultadoCaixaFornecedores, setResultadoCaixaFornecedores] =
    useState<IAuditoriaCaixaFornecedoresResultado>({
      itens: [],
      totalErros: 0,
      totalAlertas: 0,
      totalAvisos: 0,
      passivoTributarioTotal: 0,
      status: 'CONCILIADO',
      mensagemDirecionamento: '',
      fundamentacaoLegal: '',
    })
  const [resultadoCircularidadeTransitoria, setResultadoCircularidadeTransitoria] =
    useState<IAuditoriaCircularidadeTransitoriaResultado>({
      itens: [],
      totalErros: 0,
      totalAlertas: 0,
      totalAvisos: 0,
      totalErrosGiroCircular: 0,
      totalErrosSaldoAberto: 0,
      totalAlertasGiroCircular: 0,
      totalAlertasSaldoAberto: 0,
      totalAvisosGiroCircular: 0,
      totalAvisosSaldoAberto: 0,
      totalGiroCircular: 0,
      totalSaldoAberto: 0,
      passivoTributarioTotal: 0,
      passivoReferenciaTotal: 0,
      status: 'CONCILIADO',
      mensagemDirecionamento: '',
      fundamentacaoLegal: '',
      qsaDisponivel: false,
      mensagemQsa: '',
    })
  const [resultadoCorrelacaoFiscal, setResultadoCorrelacaoFiscal] =
    useState<IAuditoriaCorrelacaoFiscalResultado>({
      itens: [],
      serieMensal: [],
      totalErros: 0,
      totalAlertas: 0,
      totalAvisos: 0,
      passivoTributarioTotal: 0,
      passivoReferenciaTotal: 0,
      status: 'CONCILIADO',
      mensagemDirecionamento: '',
      fundamentacaoLegal: '',
    })
  const [resultadoPlIntegridade, setResultadoPlIntegridade] =
    useState<IAuditoriaPlIntegridadeResultado>({
      itens: [],
      totalErros: 0,
      totalAlertas: 0,
      totalAvisos: 0,
      passivoTributarioTotal: 0,
      status: 'CONCILIADO',
      mensagemDirecionamento: '',
      fundamentacaoLegal: '',
    })
  const [resultadoPayrollDrift, setResultadoPayrollDrift] =
    useState<IAuditoriaPayrollDriftResultado>({
      itens: [],
      totalAvisos: 0,
      totalAlertas: 0,
      totalErros: 0,
      impactoFinanceiroTotal: 0,
      statusGeral: 'CONCILIADO',
      mensagemDirecionamento: '',
      fundamentacaoLegal: '',
      faixasClassificacao: {limiteAviso: 10, limiteAlerta: 16, limiteErro: 30},
      contasAnalisadas: [],
    })
  const [resultadoAssetRecovery, setResultadoAssetRecovery] =
    useState<IAuditoriaAssetRecoveryResultado>({
      itens: [],
      totalAvisos: 0,
      totalAlertas: 0,
      totalErros: 0,
      passivoTotal: 0,
      statusGeral: 'CONCILIADO',
      fundamentacaoLegal: '',
    })
  const [resultadoSimCapital, setResultadoSimCapital] = useState<IAuditoriaSimCapitalResultado>({
    itens: [],
    totalAvisos: 0,
    totalAlertas: 0,
    totalErros: 0,
    passivoTotal: 0,
    statusGeral: 'CONCILIADO',
    fundamentacaoLegal: '',
  })

  useEffect(() => {
    AuditoriaService.buscarMeuAcesso()
      .then(setTier)
      .catch(() => setTier('FullPremium'))
      .finally(() => setTierCarregando(false))
  }, [])

  useEffect(() => {
    if (tierCarregando || tier === 'Nenhum') return
    carregarEmpresas()
  }, [tierCarregando, tier])

  useEffect(() => {
    if (empresaId) {
      carregarPeriodos()
    } else {
      setPeriodos([])
      setPeriodo(undefined)
    }
  }, [empresaId])

  // Diagnóstico só pode ver o resumo consolidado (TODOS) — mesmo que algum
  // estado antigo tenha ficado com um tributo individual selecionado.
  // Trial 72h só pode abrir o detalhe dos tributos de menor impacto fiscal
  // (TRIBUTOS_PERMITIDOS_TRIAL) — guard aqui é necessário porque as linhas dos cards de resumo na
  // aba TODOS também chamam selecionarTributo diretamente (não passam só pelo dropdown).
  function selecionarTributo(value: TributoAuditoria | '') {
    // "EXTRATO BANCÁRIO" não é uma auditoria com resultado próprio — é o atalho para a Central de
    // Entrada de Dados (ver AuditoriaFiltros.tsx). Redireciona direto, sem passar pelo
    // carregamento de resultado nem pelas restrições de tier abaixo (não é um módulo fiscal).
    if (value === 'EXTRATO_BANCARIO') {
      history.push({ pathname: '/auditoria/entrada-dados', state: { empresaId, periodo } })
      return
    }
    if (!value) {
      setTributo('')
      return
    }
    if (value !== 'TODOS' && tier === 'Diagnostico') return
    if (value !== 'TODOS' && tier === 'Trial72h' && !TRIBUTOS_PERMITIDOS_TRIAL.includes(value))
      return
    setTributo(value)
  }

  useEffect(() => {
    if (empresaId && periodo && tributo && tier !== 'Nenhum') {
      if (tributo === 'TODOS') carregarResultadoTodos()
      else if (tributo === 'SALDOS_BANCARIOS') carregarResultadoBancario()
      else if (tributo === 'DEPRECIACAO_AMORTIZACAO') carregarResultadoDepreciacao()
      else if (tributo === 'AUDITORIA_CAIXA') carregarResultadoCaixa()
      else if (tributo === 'AUDITORIA_FINANCEIRA') carregarResultadoFinanceira()
      else if (tributo === 'AUDITORIA_ZERAMENTO_13') carregarResultadoZeramento13()
      else if (tributo === 'AUDITORIA_BAIXA_PATRIMONIAL') carregarResultadoBaixaPatrimonial()
      else if (tributo === 'AUDITORIA_ADIANTAMENTO') carregarResultadoAdiantamento()
      else if (tributo === 'AUDITORIA_ADIANTAMENTO_CLIENTES')
        carregarResultadoAdiantamentoClientes()
      else if (tributo === 'AUDITORIA_DESPESAS_ANTECIPADAS') carregarResultadoDespesasAntecipadas()
      else if (tributo === 'AUDITORIA_AJUSTE_EXERCICIOS_ANTERIORES')
        carregarResultadoAjusteExerciciosAnteriores()
      else if (tributo === 'AUDITORIA_CONTAS_PAGAR_RECEBER') carregarResultadoContasPagarReceber()
      else if (tributo === 'AUDITORIA_FORNECEDORES_CONCILIACAO')
        carregarResultadoFornecedoresConciliacao()
      else if (tributo === 'AUDITORIA_RECEITAS_DIFERIDAS') carregarResultadoReceitasDiferidas()
      else if (tributo === 'AUDITORIA_INTEGRIDADE_LANCAMENTOS')
        carregarResultadoIntegridadeLancamentos()
      else if (tributo === 'AUDITORIA_ADIANTAMENTO_SOCIOS') carregarResultadoAdiantamentoSocios()
      else if (tributo === 'AUDITORIA_BENEFICIOS_INDIRETOS') carregarResultadoBeneficiosIndiretos()
      else if (tributo === 'AUDITORIA_RASTREABILIDADE_BANCARIA')
        carregarResultadoRastreabilidadeBancaria()
      else if (tributo === 'AUDITORIA_ARREDONDAMENTOS_AJUSTES')
        carregarResultadoArredondamentosAjustes()
      else if (tributo === 'AUDITORIA_ADIANTAMENTO_FUNCIONARIOS')
        carregarResultadoAdiantamentoFuncionarios()
      else if (tributo === 'AUDITORIA_ADIANTAMENTO_SALARIO') carregarResultadoAdiantamentoSalario()
      else if (tributo === 'AUDITORIA_ANOMALIA_TARIFA_BANCARIA')
        carregarResultadoAnomaliaTarifaBancaria()
      else if (tributo === 'AUDITORIA_CONTA_TRANSITORIA') carregarResultadoContaTransitoria()
      else if (tributo === 'AUDITORIA_ADIANTAMENTO_VIAGEM') carregarResultadoAdiantamentoViagem()
      else if (tributo === 'AUDITORIA_CLASSIFICACAO_RECEITA')
        carregarResultadoClassificacaoReceita()
      else if (tributo === 'AUDITORIA_PROVISAO_PIS_COFINS') carregarResultadoProvisaoPisCofins()
      else if (tributo === 'AUDITORIA_PROVISAO_ISS') carregarResultadoProvisaoIss()
      else if (tributo === 'AUDITORIA_PROVISAO_ICMS') carregarResultadoProvisaoIcms()
      else if (tributo === 'AUDITORIA_DUPLICIDADE_PAGAMENTOS')
        carregarResultadoDuplicidadePagamentos()
      else if (tributo === 'AUDITORIA_ROTATIVIDADE_PROVISOES')
        carregarResultadoRotatividadeProvisoes()
      else if (tributo === 'AUDITORIA_PDD_ANALITICA') carregarResultadoPddAnalitica()
      else if (tributo === 'AUDITORIA_PEJOTIZACAO') carregarResultadoPejotizacao()
      else if (tributo === 'AUDITORIA_LANCAMENTO_MANUAL') carregarResultadoLancamentoManual()
      else if (tributo === 'AUDITORIA_LANCAMENTO_ESTORNO') carregarResultadoLancamentoEstorno()
      else if (tributo === 'AUDITORIA_LANCAMENTO_DIA_NAO_UTIL')
        carregarResultadoLancamentoDiaNaoUtil()
      else if (tributo === 'AUDITORIA_DESPESA_ANALITICA_RELEVANTE')
        carregarResultadoDespesaAnaliticaRelevante()
      else if (tributo === 'AUDITORIA_LANCAMENTO_CORRETIVO') carregarResultadoLancamentoCorretivo()
      else if (tributo === 'AUDITORIA_SERVICOS_TERCEIROS_PF') carregarResultadoServicosTerceirosPf()
      else if (tributo === 'AUDITORIA_SOCIETARIA') carregarResultadoSocietaria()
      else if (tributo === 'AUDITORIA_QUALIDADE_HISTORICOS') carregarResultadoQualidadeHistoricos()
      else if (tributo === 'AUDITORIA_TRANSFER_PRICING') carregarResultadoTransferPricing()
      else if (tributo === 'AUDITORIA_CAMBIAL') carregarResultadoCambial()
      else if (tributo === 'AUDITORIA_ROUND_TRIPPING') carregarResultadoRoundTripping()
      else if (tributo === 'AUDITORIA_CASH_RICH') carregarResultadoCashRich()
      else if (tributo === 'AUDITORIA_MUTACAO_VOLATIL') carregarResultadoMutacaoVolatil()
      else if (tributo === 'AUDITORIA_CREDITO_ESTAGNADO') carregarResultadoCreditoEstagnado()
      else if (tributo === 'AUDITORIA_PROVISAO_ESPELHO') carregarResultadoProvisaoEspelho()
      else if (tributo === 'AUDITORIA_CORRELACAO_RECEITA') carregarResultadoCorrelacaoReceita()
      else if (tributo === 'AUDITORIA_VALOR_REDONDO') carregarResultadoValorRedondo()
      else if (tributo === 'AUDITORIA_OUTRAS_DESPESAS') carregarResultadoOutrasDespesas()
      else if (tributo === 'AUDITORIA_ESTOQUE_SEM_MOVIMENTO') carregarResultadoEstoqueSemMovimento()
      else if (tributo === 'AUDITORIA_SPLIT_DESPESAS') carregarResultadoSplitDespesas()
      else if (tributo === 'AUDITORIA_CAIXA_FORNECEDORES') carregarResultadoCaixaFornecedores()
      else if (tributo === 'AUDITORIA_CIRCULARIDADE_TRANSITORIA')
        carregarResultadoCircularidadeTransitoria()
      else if (tributo === 'AUDITORIA_CORRELACAO_FISCAL') carregarResultadoCorrelacaoFiscal()
      else if (tributo === 'AUDITORIA_PL_INTEGRIDADE') carregarResultadoPlIntegridade()
      else if (tributo === 'AUDITORIA_PAYROLL_DRIFT') carregarResultadoPayrollDrift()
      else if (tributo === 'AUDITORIA_ASSET_RECOVERY') carregarResultadoAssetRecovery()
      else if (tributo === 'AUDITORIA_SIM_CAPITAL') carregarResultadoSimCapital()
      else carregarResultado()
    }
  }, [empresaId, periodo, tributo, tier])

  // DEVN3-521 — dispara a geração do laudo (idempotente) assim que empresa+período estão
  // definidos, sem depender do "Tipo de Auditoria" nem bloquear o fluxo atual. Faz polling
  // enquanto ainda está gerando; encerra sozinho quando todos os capítulos existem.
  useEffect(() => {
    if (!empresaId || !periodo || tier === 'Nenhum') {
      setLaudo(null)
      return
    }

    let cancelado = false
    let timer: ReturnType<typeof setTimeout> | undefined

    const tick = async () => {
      try {
        await LaudoAuditoriaService.garantir(periodo)
        const l = await LaudoAuditoriaService.buscar(periodo)
        if (cancelado) return
        setLaudo(l)
        const emAndamento = !!l && (l.status === 'GERANDO' || l.arquivoRetornoProcessando)
        if (emAndamento) timer = setTimeout(tick, 8000)
      } catch {
        /* silencioso — a tela de auditoria segue funcionando sem o laudo */
      }
    }
    tick()

    return () => {
      cancelado = true
      if (timer) clearTimeout(timer)
    }
  }, [empresaId, periodo, tier])

  async function exportarLaudo(formato: 'PDF' | 'DOCX' = 'PDF') {
    if (!periodo || !laudo?.exportHabilitado) return
    setExportandoLaudo(true)
    setErro(undefined)
    setErro(await exportarLaudoEBaixar(periodo, formato, setLaudo))
    setExportandoLaudo(false)
  }

  async function carregarEmpresas() {
    try {
      setLoading(true)
      setErro(undefined)
      const response = await AuditoriaService.listarEmpresas()
      setEmpresas(response)
      const empresaInicial = selecaoInicial.current?.empresa
      if (empresaInicial && response.some((e) => e.id === empresaInicial)) {
        setEmpresaId(empresaInicial)
        setPeriodo(undefined)
        // Mesmo estado de quem acabou de escolher a empresa no filtro (COR-191).
        setTributo(tier === 'Diagnostico' ? 'TODOS' : '')
      } else {
        selecaoInicial.current = undefined
        setEmpresaId(undefined)
        setPeriodo(undefined)
        setTributo('TODOS')
      }
      setResultado({cards: [], empresas: []})
    } catch {
      setErro('Erro ao carregar empresas')
    } finally {
      setLoading(false)
    }
  }

  async function carregarPeriodos() {
    try {
      setErro(undefined)
      const response = await AuditoriaService.listarPeriodos(Number(empresaId))
      setPeriodos(response)
      const periodoInicial =
        selecaoInicial.current?.empresa === empresaId ? selecaoInicial.current?.periodo : undefined
      selecaoInicial.current = undefined
      setPeriodo(
        periodoInicial && response.some((p) => String(p.esteiraId) === periodoInicial)
          ? periodoInicial
          : undefined
      )
    } catch {
      setErro('Erro ao carregar períodos')
    }
  }

  async function carregarResultado() {
    try {
      setLoading(true)
      setErro(undefined)
      // Só chega aqui quando o useEffect já garantiu tributo truthy (branch "else" após checar
      // os tributos fiscais individuais) — a assinatura do state é mais ampla (aceita '') só
      // para representar "nada selecionado ainda" no dropdown, ver COR-191.
      const response = await AuditoriaService.buscarResultado({
        empresaId: Number(empresaId),
        periodo,
        tributo: tributo as TributoAuditoria,
      })
      setResultado({cards: response?.cards || [], empresas: response?.empresas || []})
    } catch {
      setErro('Erro ao carregar auditoria')
    } finally {
      setLoading(false)
    }
  }

  async function carregarResultadoBancario() {
    try {
      setLoading(true)
      setErro(undefined)
      setResultadoBancario(
        await AuditoriaBancariaService.buscarResultado({empresaId: Number(empresaId), periodo})
      )
    } catch {
      setErro('Erro ao carregar auditoria de saldos bancários')
    } finally {
      setLoading(false)
    }
  }
  async function carregarResultadoDepreciacao() {
    try {
      setLoading(true)
      setErro(undefined)
      setResultadoDepreciacao(
        await AuditoriaDepreciacaoService.buscarResultado({empresaId: Number(empresaId), periodo})
      )
    } catch {
      setErro('Erro ao carregar auditoria de depreciação/amortização/exaustão')
    } finally {
      setLoading(false)
    }
  }
  async function carregarResultadoCaixa() {
    try {
      setLoading(true)
      setErro(undefined)
      setResultadoCaixa(
        await AuditoriaCaixaService.buscarResultado({empresaId: Number(empresaId), periodo})
      )
    } catch {
      setErro('Erro ao carregar auditoria de caixa, espécie e forense')
    } finally {
      setLoading(false)
    }
  }
  async function carregarResultadoFinanceira() {
    try {
      setLoading(true)
      setErro(undefined)
      setResultadoFinanceira(
        await AuditoriaFinanceiraService.buscarResultado({empresaId: Number(empresaId), periodo})
      )
    } catch {
      setErro('Erro ao carregar auditoria de resgate e IRRF sobre aplicações financeiras')
    } finally {
      setLoading(false)
    }
  }
  async function carregarResultadoZeramento13() {
    try {
      setLoading(true)
      setErro(undefined)
      setResultadoZeramento13(
        await AuditoriaZeramento13Service.buscarResultado({empresaId: Number(empresaId), periodo})
      )
    } catch {
      setErro('Erro ao carregar auditoria de zeramento e provisão de 13º salário')
    } finally {
      setLoading(false)
    }
  }
  async function carregarResultadoBaixaPatrimonial() {
    try {
      setLoading(true)
      setErro(undefined)
      setResultadoBaixaPatrimonial(
        await AuditoriaBaixaPatrimonialService.buscarResultado({
          empresaId: Number(empresaId),
          periodo,
        })
      )
    } catch {
      setErro('Erro ao carregar auditoria de baixa direta de ativo imobilizado')
    } finally {
      setLoading(false)
    }
  }
  async function carregarResultadoAdiantamento() {
    try {
      setLoading(true)
      setErro(undefined)
      setResultadoAdiantamento(
        await AuditoriaAdiantamentoService.buscarResultado({empresaId: Number(empresaId), periodo})
      )
    } catch {
      setErro('Erro ao carregar auditoria de competência de adiantamentos')
    } finally {
      setLoading(false)
    }
  }
  async function carregarResultadoAdiantamentoClientes() {
    try {
      setLoading(true)
      setErro(undefined)
      setResultadoAdiantamentoClientes(
        await AuditoriaAdiantamentoClientesService.buscarResultado({
          empresaId: Number(empresaId),
          periodo,
        })
      )
    } catch {
      setErro('Erro ao carregar auditoria de adiantamentos de clientes')
    } finally {
      setLoading(false)
    }
  }
  async function carregarResultadoDespesasAntecipadas() {
    try {
      setLoading(true)
      setErro(undefined)
      setResultadoDespesasAntecipadas(
        await AuditoriaDespesasAntecipadasService.buscarResultado({
          empresaId: Number(empresaId),
          periodo,
        })
      )
    } catch {
      setErro('Erro ao carregar auditoria de despesas antecipadas')
    } finally {
      setLoading(false)
    }
  }
  async function carregarResultadoAjusteExerciciosAnteriores() {
    try {
      setLoading(true)
      setErro(undefined)
      setResultadoAjusteExerciciosAnteriores(
        await AuditoriaAjusteExerciciosAnterioresService.buscarResultado({
          empresaId: Number(empresaId),
          periodo,
        })
      )
    } catch {
      setErro('Erro ao carregar auditoria de ajustes de exercícios anteriores')
    } finally {
      setLoading(false)
    }
  }
  async function carregarResultadoContasPagarReceber() {
    try {
      setLoading(true)
      setErro(undefined)
      setResultadoContasPagarReceber(
        await AuditoriaContasPagarReceberService.buscarResultado({
          empresaId: Number(empresaId),
          periodo,
        })
      )
    } catch {
      setErro('Erro ao carregar auditoria de contas a pagar e a receber')
    } finally {
      setLoading(false)
    }
  }
  async function carregarResultadoFornecedoresConciliacao() {
    try {
      setLoading(true)
      setErro(undefined)
      setResultadoFornecedoresConciliacao(
        await AuditoriaFornecedoresConciliacaoService.buscarResultado({
          empresaId: Number(empresaId),
          periodo,
        })
      )
    } catch {
      setErro('Erro ao carregar auditoria de fornecedores (conciliação)')
    } finally {
      setLoading(false)
    }
  }
  async function carregarResultadoReceitasDiferidas() {
    try {
      setLoading(true)
      setErro(undefined)
      setResultadoReceitasDiferidas(
        await AuditoriaReceitasDiferidasService.buscarResultado({
          empresaId: Number(empresaId),
          periodo,
        })
      )
    } catch {
      setErro('Erro ao carregar auditoria de receitas diferidas')
    } finally {
      setLoading(false)
    }
  }
  async function carregarResultadoIntegridadeLancamentos() {
    try {
      setLoading(true)
      setErro(undefined)
      setResultadoIntegridadeLancamentos(
        await AuditoriaIntegridadeLancamentosService.buscarResultado({
          empresaId: Number(empresaId),
          periodo,
        })
      )
    } catch {
      setErro('Erro ao carregar auditoria de integridade de lançamentos')
    } finally {
      setLoading(false)
    }
  }
  async function carregarResultadoAdiantamentoSocios() {
    try {
      setLoading(true)
      setErro(undefined)
      setResultadoAdiantamentoSocios(
        await AuditoriaAdiantamentoSociosService.buscarResultado({
          empresaId: Number(empresaId),
          periodo,
        })
      )
    } catch {
      setErro('Erro ao carregar auditoria de adiantamentos a sócios')
    } finally {
      setLoading(false)
    }
  }
  async function carregarResultadoBeneficiosIndiretos() {
    try {
      setLoading(true)
      setErro(undefined)
      setResultadoBeneficiosIndiretos(
        await AuditoriaBeneficiosIndiretosService.buscarResultado({
          empresaId: Number(empresaId),
          periodo,
        })
      )
    } catch {
      setErro('Erro ao carregar auditoria de benefícios indiretos a sócios')
    } finally {
      setLoading(false)
    }
  }
  async function carregarResultadoRastreabilidadeBancaria() {
    try {
      setLoading(true)
      setErro(undefined)
      setResultadoRastreabilidadeBancaria(
        await AuditoriaRastreabilidadeBancariaService.buscarResultado({
          empresaId: Number(empresaId),
          periodo,
        })
      )
    } catch {
      setErro('Erro ao carregar auditoria de rastreabilidade bancária')
    } finally {
      setLoading(false)
    }
  }
  async function carregarResultadoArredondamentosAjustes() {
    try {
      setLoading(true)
      setErro(undefined)
      setResultadoArredondamentosAjustes(
        await AuditoriaArredondamentosAjustesService.buscarResultado({
          empresaId: Number(empresaId),
          periodo,
        })
      )
    } catch {
      setErro('Erro ao carregar auditoria de arredondamentos e lançamentos de ajustes')
    } finally {
      setLoading(false)
    }
  }
  async function carregarResultadoAdiantamentoFuncionarios() {
    try {
      setLoading(true)
      setErro(undefined)
      setResultadoAdiantamentoFuncionarios(
        await AuditoriaAdiantamentoFuncionariosService.buscarResultado({
          empresaId: Number(empresaId),
          periodo,
        })
      )
    } catch {
      setErro('Erro ao carregar auditoria de adiantamentos e empréstimos a funcionários')
    } finally {
      setLoading(false)
    }
  }
  async function carregarResultadoAdiantamentoSalario() {
    try {
      setLoading(true)
      setErro(undefined)
      setResultadoAdiantamentoSalario(
        await AuditoriaAdiantamentoSalarioService.buscarResultado({
          empresaId: Number(empresaId),
          periodo,
        })
      )
    } catch {
      setErro('Erro ao carregar auditoria de adiantamento de salários')
    } finally {
      setLoading(false)
    }
  }
  async function carregarResultadoAnomaliaTarifaBancaria() {
    try {
      setLoading(true)
      setErro(undefined)
      setResultadoAnomaliaTarifaBancaria(
        await AuditoriaAnomaliaTarifaBancariaService.buscarResultado({
          empresaId: Number(empresaId),
          periodo,
        })
      )
    } catch {
      setErro('Erro ao carregar auditoria de anomalias em tarifas bancárias')
    } finally {
      setLoading(false)
    }
  }
  async function carregarResultadoContaTransitoria() {
    try {
      setLoading(true)
      setErro(undefined)
      setResultadoContaTransitoria(
        await AuditoriaContaTransitoriaService.buscarResultado({
          empresaId: Number(empresaId),
          periodo,
        })
      )
    } catch {
      setErro('Erro ao carregar auditoria de conciliação de contas transitórias')
    } finally {
      setLoading(false)
    }
  }
  async function carregarResultadoAdiantamentoViagem() {
    try {
      setLoading(true)
      setErro(undefined)
      setResultadoAdiantamentoViagem(
        await AuditoriaAdiantamentoViagemService.buscarResultado({
          empresaId: Number(empresaId),
          periodo,
        })
      )
    } catch {
      setErro('Erro ao carregar auditoria de adiantamentos de viagens')
    } finally {
      setLoading(false)
    }
  }
  async function carregarResultadoClassificacaoReceita() {
    try {
      setLoading(true)
      setErro(undefined)
      setResultadoClassificacaoReceita(
        await AuditoriaClassificacaoReceitaService.buscarResultado({
          empresaId: Number(empresaId),
          periodo,
        })
      )
    } catch {
      setErro('Erro ao carregar auditoria de classificação de contas de receita')
    } finally {
      setLoading(false)
    }
  }
  async function carregarResultadoProvisaoPisCofins() {
    try {
      setLoading(true)
      setErro(undefined)
      setResultadoProvisaoPisCofins(
        await AuditoriaProvisaoPisCofinsService.buscarResultado({
          empresaId: Number(empresaId),
          periodo,
        })
      )
    } catch {
      setErro('Erro ao carregar auditoria de provisão mensal de PIS/COFINS')
    } finally {
      setLoading(false)
    }
  }
  async function carregarResultadoProvisaoIss() {
    try {
      setLoading(true)
      setErro(undefined)
      setResultadoProvisaoIss(
        await AuditoriaProvisaoIssService.buscarResultado({empresaId: Number(empresaId), periodo})
      )
    } catch {
      setErro('Erro ao carregar auditoria de provisão mensal de ISS')
    } finally {
      setLoading(false)
    }
  }
  async function carregarResultadoProvisaoIcms() {
    try {
      setLoading(true)
      setErro(undefined)
      setResultadoProvisaoIcms(
        await AuditoriaProvisaoIcmsService.buscarResultado({empresaId: Number(empresaId), periodo})
      )
    } catch {
      setErro('Erro ao carregar auditoria de provisão mensal de ICMS')
    } finally {
      setLoading(false)
    }
  }
  async function carregarResultadoDuplicidadePagamentos() {
    try {
      setLoading(true)
      setErro(undefined)
      setResultadoDuplicidadePagamentos(
        await AuditoriaDuplicidadePagamentosService.buscarResultado({
          empresaId: Number(empresaId),
          periodo,
        })
      )
    } catch {
      setErro('Erro ao carregar auditoria de duplicidade de pagamentos')
    } finally {
      setLoading(false)
    }
  }
  async function carregarResultadoRotatividadeProvisoes() {
    try {
      setLoading(true)
      setErro(undefined)
      setResultadoRotatividadeProvisoes(
        await AuditoriaRotatividadeProvisoesService.buscarResultado({
          empresaId: Number(empresaId),
          periodo,
        })
      )
    } catch {
      setErro('Erro ao carregar auditoria de rotatividade de provisões')
    } finally {
      setLoading(false)
    }
  }
  async function carregarResultadoPddAnalitica() {
    try {
      setLoading(true)
      setErro(undefined)
      setResultadoPddAnalitica(
        await AuditoriaPddAnaliticaService.buscarResultado({empresaId: Number(empresaId), periodo})
      )
    } catch {
      setErro('Erro ao carregar auditoria de PDD analítica')
    } finally {
      setLoading(false)
    }
  }
  async function carregarResultadoPejotizacao() {
    try {
      setLoading(true)
      setErro(undefined)
      setResultadoPejotizacao(
        await AuditoriaPejotizacaoService.buscarResultado({empresaId: Number(empresaId), periodo})
      )
    } catch {
      setErro('Erro ao carregar auditoria de pejotização')
    } finally {
      setLoading(false)
    }
  }
  async function carregarResultadoLancamentoManual() {
    try {
      setLoading(true)
      setErro(undefined)
      setResultadoLancamentoManual(
        await AuditoriaLancamentoManualService.buscarResultado({
          empresaId: Number(empresaId),
          periodo,
        })
      )
    } catch {
      setErro('Erro ao carregar auditoria de lançamentos manuais')
    } finally {
      setLoading(false)
    }
  }
  async function carregarResultadoLancamentoEstorno() {
    try {
      setLoading(true)
      setErro(undefined)
      setResultadoLancamentoEstorno(
        await AuditoriaLancamentoEstornoService.buscarResultado({
          empresaId: Number(empresaId),
          periodo,
        })
      )
    } catch {
      setErro('Erro ao carregar auditoria de lançamentos de estorno')
    } finally {
      setLoading(false)
    }
  }

  async function carregarResultadoLancamentoDiaNaoUtil() {
    try {
      setLoading(true)
      setErro(undefined)
      setResultadoLancamentoDiaNaoUtil(
        await AuditoriaLancamentoDiaNaoUtilService.buscarResultado({
          empresaId: Number(empresaId),
          periodo,
        })
      )
    } catch {
      setErro('Erro ao carregar auditoria de lançamentos em dia não útil')
    } finally {
      setLoading(false)
    }
  }

  async function carregarResultadoDespesaAnaliticaRelevante() {
    try {
      setLoading(true)
      setErro(undefined)
      setResultadoDespesaAnaliticaRelevante(
        await AuditoriaDespesaAnaliticaRelevanteService.buscarResultado({
          empresaId: Number(empresaId),
          periodo,
        })
      )
    } catch {
      setErro('Erro ao carregar auditoria de despesas analíticas relevantes')
    } finally {
      setLoading(false)
    }
  }

  async function carregarResultadoLancamentoCorretivo() {
    try {
      setLoading(true)
      setErro(undefined)
      setResultadoLancamentoCorretivo(
        await AuditoriaLancamentoCorretivoService.buscarResultado({
          empresaId: Number(empresaId),
          periodo,
        })
      )
    } catch {
      setErro('Erro ao carregar auditoria de lançamentos corretivos')
    } finally {
      setLoading(false)
    }
  }

  async function carregarResultadoServicosTerceirosPf() {
    try {
      setLoading(true)
      setErro(undefined)
      setResultadoServicosTerceirosPf(
        await AuditoriaServicosTerceirosPfService.buscarResultado({
          empresaId: Number(empresaId),
          periodo,
        })
      )
    } catch {
      setErro('Erro ao carregar auditoria de serviços de terceiros (pessoa física)')
    } finally {
      setLoading(false)
    }
  }
  async function carregarResultadoSocietaria() {
    try {
      setLoading(true)
      setErro(undefined)
      setResultadoSocietaria(
        await AuditoriaSocietariaService.buscarResultado({empresaId: Number(empresaId), periodo})
      )
    } catch {
      setErro('Erro ao carregar auditoria societária')
    } finally {
      setLoading(false)
    }
  }
  async function carregarResultadoQualidadeHistoricos() {
    try {
      setLoading(true)
      setErro(undefined)
      setQualidadeProcessando(false)
      // DEVN3-593: empresa com muito lancamento -> a API responde 202 e o worker processa; o servico
      // faz polling ate o resultado ficar pronto (aoAguardar so liga o aviso "processando").
      setResultadoQualidadeHistoricos(
        await AuditoriaQualidadeHistoricosService.buscarResultado(
          {
            empresaId: Number(empresaId),
            periodo,
          },
          {aoAguardar: () => setQualidadeProcessando(true)}
        )
      )
    } catch {
      setErro('Erro ao carregar auditoria de qualidade de históricos')
    } finally {
      setQualidadeProcessando(false)
      setLoading(false)
    }
  }
  async function carregarResultadoTransferPricing() {
    try {
      setLoading(true)
      setErro(undefined)
      setResultadoTransferPricing(
        await AuditoriaTransferPricingService.buscarResultado({
          empresaId: Number(empresaId),
          periodo,
        })
      )
    } catch {
      setErro('Erro ao carregar auditoria de transfer pricing')
    } finally {
      setLoading(false)
    }
  }
  async function carregarResultadoCambial() {
    try {
      setLoading(true)
      setErro(undefined)
      setResultadoCambial(
        await AuditoriaCambialService.buscarResultado({empresaId: Number(empresaId), periodo})
      )
    } catch {
      setErro('Erro ao carregar auditoria de exposição cambial')
    } finally {
      setLoading(false)
    }
  }
  async function carregarResultadoRoundTripping() {
    try {
      setLoading(true)
      setErro(undefined)
      setResultadoRoundTripping(
        await AuditoriaRoundTrippingService.buscarResultado({empresaId: Number(empresaId), periodo})
      )
    } catch {
      setErro('Erro ao carregar auditoria de round-tripping')
    } finally {
      setLoading(false)
    }
  }
  async function carregarResultadoCashRich() {
    try {
      setLoading(true)
      setErro(undefined)
      setResultadoCashRich(
        await AuditoriaCashRichService.buscarResultado({empresaId: Number(empresaId), periodo})
      )
    } catch {
      setErro('Erro ao carregar auditoria cash-rich')
    } finally {
      setLoading(false)
    }
  }
  async function carregarResultadoMutacaoVolatil() {
    try {
      setLoading(true)
      setErro(undefined)
      setResultadoMutacaoVolatil(
        await AuditoriaMutacaoVolatilService.buscarResultado({
          empresaId: Number(empresaId),
          periodo,
        })
      )
    } catch {
      setErro('Erro ao carregar auditoria de mutação volátil')
    } finally {
      setLoading(false)
    }
  }
  async function carregarResultadoCreditoEstagnado() {
    try {
      setLoading(true)
      setErro(undefined)
      setResultadoCreditoEstagnado(
        await AuditoriaCreditoEstagnadoService.buscarResultado({
          empresaId: Number(empresaId),
          periodo,
        })
      )
    } catch {
      setErro('Erro ao carregar auditoria de créditos fiscais estagnados')
    } finally {
      setLoading(false)
    }
  }
  async function carregarResultadoProvisaoEspelho() {
    try {
      setLoading(true)
      setErro(undefined)
      setResultadoProvisaoEspelho(
        await AuditoriaProvisaoEspelhoService.buscarResultado({
          empresaId: Number(empresaId),
          periodo,
        })
      )
    } catch {
      setErro('Erro ao carregar auditoria de provisões espelho')
    } finally {
      setLoading(false)
    }
  }
  async function carregarResultadoCorrelacaoReceita() {
    try {
      setLoading(true)
      setErro(undefined)
      setResultadoCorrelacaoReceita(
        await AuditoriaCorrelacaoReceitaService.buscarResultado({
          empresaId: Number(empresaId),
          periodo,
        })
      )
    } catch {
      setErro('Erro ao carregar auditoria de correlação receita bruta / redutoras')
    } finally {
      setLoading(false)
    }
  }
  async function carregarResultadoValorRedondo() {
    try {
      setLoading(true)
      setErro(undefined)
      setResultadoValorRedondo(
        await AuditoriaValorRedondoService.buscarResultado({empresaId: Number(empresaId), periodo})
      )
    } catch {
      setErro('Erro ao carregar auditoria de valores redondos')
    } finally {
      setLoading(false)
    }
  }
  async function carregarResultadoOutrasDespesas() {
    try {
      setLoading(true)
      setErro(undefined)
      setResultadoOutrasDespesas(
        await AuditoriaOutrasDespesasService.buscarResultado({
          empresaId: Number(empresaId),
          periodo,
        })
      )
    } catch {
      setErro('Erro ao carregar auditoria de outras despesas')
    } finally {
      setLoading(false)
    }
  }
  async function carregarResultadoEstoqueSemMovimento() {
    try {
      setLoading(true)
      setErro(undefined)
      setResultadoEstoqueSemMovimento(
        await AuditoriaEstoqueSemMovimentoService.buscarResultado({
          empresaId: Number(empresaId),
          periodo,
        })
      )
    } catch {
      setErro('Erro ao carregar auditoria de estoques sem movimento')
    } finally {
      setLoading(false)
    }
  }
  async function carregarResultadoSplitDespesas() {
    try {
      setLoading(true)
      setErro(undefined)
      setResultadoSplitDespesas(
        await AuditoriaSplitDespesasService.buscarResultado({empresaId: Number(empresaId), periodo})
      )
    } catch {
      setErro('Erro ao carregar auditoria de fragmentação de despesas')
    } finally {
      setLoading(false)
    }
  }
  async function carregarResultadoCaixaFornecedores() {
    try {
      setLoading(true)
      setErro(undefined)
      setResultadoCaixaFornecedores(
        await AuditoriaCaixaFornecedoresService.buscarResultado({
          empresaId: Number(empresaId),
          periodo,
        })
      )
    } catch {
      setErro('Erro ao carregar auditoria de pagamentos a fornecedores via caixa')
    } finally {
      setLoading(false)
    }
  }
  async function carregarResultadoCircularidadeTransitoria() {
    try {
      setLoading(true)
      setErro(undefined)
      setResultadoCircularidadeTransitoria(
        await AuditoriaCircularidadeTransitoriaService.buscarResultado({
          empresaId: Number(empresaId),
          periodo,
        })
      )
    } catch {
      setErro('Erro ao carregar auditoria de circularidade em contas transitórias')
    } finally {
      setLoading(false)
    }
  }
  async function carregarResultadoCorrelacaoFiscal() {
    try {
      setLoading(true)
      setErro(undefined)
      setResultadoCorrelacaoFiscal(
        await AuditoriaCorrelacaoFiscalService.buscarResultado({
          empresaId: Number(empresaId),
          periodo,
        })
      )
    } catch {
      setErro('Erro ao carregar auditoria de correlação receita × impostos')
    } finally {
      setLoading(false)
    }
  }
  async function carregarResultadoPlIntegridade() {
    try {
      setLoading(true)
      setErro(undefined)
      setResultadoPlIntegridade(
        await AuditoriaPlIntegridadeService.buscarResultado({empresaId: Number(empresaId), periodo})
      )
    } catch {
      setErro('Erro ao carregar auditoria de integridade do patrimônio líquido')
    } finally {
      setLoading(false)
    }
  }
  async function carregarResultadoPayrollDrift() {
    try {
      setLoading(true)
      setErro(undefined)
      setResultadoPayrollDrift(
        await AuditoriaPayrollDriftService.buscarResultado({empresaId: Number(empresaId), periodo})
      )
    } catch {
      setErro('Erro ao carregar auditoria de payroll drift')
    } finally {
      setLoading(false)
    }
  }
  async function carregarResultadoAssetRecovery() {
    try {
      setLoading(true)
      setErro(undefined)
      setResultadoAssetRecovery(
        await AuditoriaAssetRecoveryService.buscarResultado({empresaId: Number(empresaId), periodo})
      )
    } catch {
      setErro('Erro ao carregar auditoria de asset recovery')
    } finally {
      setLoading(false)
    }
  }
  async function carregarResultadoSimCapital() {
    try {
      setLoading(true)
      setErro(undefined)
      setResultadoSimCapital(
        await AuditoriaSimCapitalService.buscarResultado({empresaId: Number(empresaId), periodo})
      )
    } catch {
      setErro('Erro ao carregar auditoria de simetria de capital')
    } finally {
      setLoading(false)
    }
  }

  // Paralelizado (Promise.allSettled) — decisão explícita do usuário em 2026-07-09, ciente do
  // motivo pelo qual isto era sequencial antes: a aba "TODOS" já tinha sido medida disparando
  // ~37 requisições simultâneas contra a mesma esteira, o que causava timeout em empresas grandes
  // quando cada uma recalculava contra ControleTributos (dezenas de milhões de linhas) a cada
  // request. Isso mudou: hoje 35 dos 38 módulos tentam servir de auditoria_resultado_modulo
  // (tabela pequena, indexada, populada pelo pipeline assíncrono pós-import do ECD) antes de
  // recalcular — ver AUDITORIA-PIPELINE.MD. O risco antigo NÃO está zerado: se a esteira não tiver
  // resultado pré-processado (esteira antiga, execução falhou, reprocessamento pendente), o
  // fallback on-demand ainda recalcula pesado, e paralelizar reproduz o cenário que causou o
  // timeout medido — se isso voltar a acontecer, considerar voltar a sequencial ou usar um lote
  // com limite de concorrência em vez de todas as 37 chamadas de uma vez.
  // allSettled (não Promise.all) preserva a mesma propriedade do laço sequencial anterior: uma
  // falha isolada não descarta os resultados dos módulos que já responderam, porque cada "passo"
  // já atualiza seu próprio estado dentro de si mesmo.
  async function carregarResultadoTodos() {
    setLoading(true)
    setErro(undefined)

    const passos: Array<{nome: string; fn: () => Promise<void>}> = [
      {
        nome: 'Resultado Geral',
        fn: async () => {
          const r = await AuditoriaService.buscarResultado({
            empresaId: Number(empresaId),
            periodo,
            tributo: 'TODOS',
          })
          setResultado({cards: r?.cards || [], empresas: r?.empresas || []})
        },
      },
      {
        nome: 'Bancário',
        fn: async () =>
          setResultadoBancario(
            await AuditoriaBancariaService.buscarResultado({empresaId: Number(empresaId), periodo})
          ),
      },
      {
        nome: 'Depreciação',
        fn: async () =>
          setResultadoDepreciacao(
            await AuditoriaDepreciacaoService.buscarResultado({
              empresaId: Number(empresaId),
              periodo,
            })
          ),
      },
      {
        nome: 'Caixa',
        fn: async () =>
          setResultadoCaixa(
            await AuditoriaCaixaService.buscarResultado({empresaId: Number(empresaId), periodo})
          ),
      },
      {
        nome: 'Financeira',
        fn: async () =>
          setResultadoFinanceira(
            await AuditoriaFinanceiraService.buscarResultado({
              empresaId: Number(empresaId),
              periodo,
            })
          ),
      },
      {
        nome: 'Zeramento 13°',
        fn: async () =>
          setResultadoZeramento13(
            await AuditoriaZeramento13Service.buscarResultado({
              empresaId: Number(empresaId),
              periodo,
            })
          ),
      },
      {
        nome: 'Baixa Patrimonial',
        fn: async () =>
          setResultadoBaixaPatrimonial(
            await AuditoriaBaixaPatrimonialService.buscarResultado({
              empresaId: Number(empresaId),
              periodo,
            })
          ),
      },
      {
        nome: 'Adiantamento',
        fn: async () =>
          setResultadoAdiantamento(
            await AuditoriaAdiantamentoService.buscarResultado({
              empresaId: Number(empresaId),
              periodo,
            })
          ),
      },
      {
        nome: 'Adiantamento Clientes',
        fn: async () =>
          setResultadoAdiantamentoClientes(
            await AuditoriaAdiantamentoClientesService.buscarResultado({
              empresaId: Number(empresaId),
              periodo,
            })
          ),
      },
      {
        nome: 'Despesas Antecipadas',
        fn: async () =>
          setResultadoDespesasAntecipadas(
            await AuditoriaDespesasAntecipadasService.buscarResultado({
              empresaId: Number(empresaId),
              periodo,
            })
          ),
      },
      {
        nome: 'Ajuste Exercícios Anteriores',
        fn: async () =>
          setResultadoAjusteExerciciosAnteriores(
            await AuditoriaAjusteExerciciosAnterioresService.buscarResultado({
              empresaId: Number(empresaId),
              periodo,
            })
          ),
      },
      {
        nome: 'Contas Pagar/Receber',
        fn: async () =>
          setResultadoContasPagarReceber(
            await AuditoriaContasPagarReceberService.buscarResultado({
              empresaId: Number(empresaId),
              periodo,
            })
          ),
      },
      {
        nome: 'Fornecedores Conciliação',
        fn: async () =>
          setResultadoFornecedoresConciliacao(
            await AuditoriaFornecedoresConciliacaoService.buscarResultado({
              empresaId: Number(empresaId),
              periodo,
            })
          ),
      },
      {
        nome: 'Receitas Diferidas',
        fn: async () =>
          setResultadoReceitasDiferidas(
            await AuditoriaReceitasDiferidasService.buscarResultado({
              empresaId: Number(empresaId),
              periodo,
            })
          ),
      },
      {
        nome: 'Integridade Lançamentos',
        fn: async () =>
          setResultadoIntegridadeLancamentos(
            await AuditoriaIntegridadeLancamentosService.buscarResultado({
              empresaId: Number(empresaId),
              periodo,
            })
          ),
      },
      {
        nome: 'Adiantamento Sócios',
        fn: async () =>
          setResultadoAdiantamentoSocios(
            await AuditoriaAdiantamentoSociosService.buscarResultado({
              empresaId: Number(empresaId),
              periodo,
            })
          ),
      },
      {
        nome: 'Benefícios Indiretos',
        fn: async () =>
          setResultadoBeneficiosIndiretos(
            await AuditoriaBeneficiosIndiretosService.buscarResultado({
              empresaId: Number(empresaId),
              periodo,
            })
          ),
      },
      {
        nome: 'Rastreabilidade Bancária',
        fn: async () =>
          setResultadoRastreabilidadeBancaria(
            await AuditoriaRastreabilidadeBancariaService.buscarResultado({
              empresaId: Number(empresaId),
              periodo,
            })
          ),
      },
      {
        nome: 'Arredondamentos/Ajustes',
        fn: async () =>
          setResultadoArredondamentosAjustes(
            await AuditoriaArredondamentosAjustesService.buscarResultado({
              empresaId: Number(empresaId),
              periodo,
            })
          ),
      },
      {
        nome: 'Adiantamento Funcionários',
        fn: async () =>
          setResultadoAdiantamentoFuncionarios(
            await AuditoriaAdiantamentoFuncionariosService.buscarResultado({
              empresaId: Number(empresaId),
              periodo,
            })
          ),
      },
      {
        nome: 'Adiantamento Salário',
        fn: async () =>
          setResultadoAdiantamentoSalario(
            await AuditoriaAdiantamentoSalarioService.buscarResultado({
              empresaId: Number(empresaId),
              periodo,
            })
          ),
      },
      {
        nome: 'Anomalia Tarifa Bancária',
        fn: async () =>
          setResultadoAnomaliaTarifaBancaria(
            await AuditoriaAnomaliaTarifaBancariaService.buscarResultado({
              empresaId: Number(empresaId),
              periodo,
            })
          ),
      },
      {
        nome: 'Conta Transitória',
        fn: async () =>
          setResultadoContaTransitoria(
            await AuditoriaContaTransitoriaService.buscarResultado({
              empresaId: Number(empresaId),
              periodo,
            })
          ),
      },
      {
        nome: 'Adiantamento Viagem',
        fn: async () =>
          setResultadoAdiantamentoViagem(
            await AuditoriaAdiantamentoViagemService.buscarResultado({
              empresaId: Number(empresaId),
              periodo,
            })
          ),
      },
      {
        nome: 'Classificação Receita',
        fn: async () =>
          setResultadoClassificacaoReceita(
            await AuditoriaClassificacaoReceitaService.buscarResultado({
              empresaId: Number(empresaId),
              periodo,
            })
          ),
      },
      {
        nome: 'Provisão PIS/COFINS',
        fn: async () =>
          setResultadoProvisaoPisCofins(
            await AuditoriaProvisaoPisCofinsService.buscarResultado({
              empresaId: Number(empresaId),
              periodo,
            })
          ),
      },
      {
        nome: 'Provisão ISS',
        fn: async () =>
          setResultadoProvisaoIss(
            await AuditoriaProvisaoIssService.buscarResultado({
              empresaId: Number(empresaId),
              periodo,
            })
          ),
      },
      {
        nome: 'Provisão ICMS',
        fn: async () =>
          setResultadoProvisaoIcms(
            await AuditoriaProvisaoIcmsService.buscarResultado({
              empresaId: Number(empresaId),
              periodo,
            })
          ),
      },
      {
        nome: 'Duplicidade Pagamentos',
        fn: async () =>
          setResultadoDuplicidadePagamentos(
            await AuditoriaDuplicidadePagamentosService.buscarResultado({
              empresaId: Number(empresaId),
              periodo,
            })
          ),
      },
      {
        nome: 'Rotatividade Provisões',
        fn: async () =>
          setResultadoRotatividadeProvisoes(
            await AuditoriaRotatividadeProvisoesService.buscarResultado({
              empresaId: Number(empresaId),
              periodo,
            })
          ),
      },
      {
        nome: 'PDD Analítica',
        fn: async () =>
          setResultadoPddAnalitica(
            await AuditoriaPddAnaliticaService.buscarResultado({
              empresaId: Number(empresaId),
              periodo,
            })
          ),
      },
      {
        nome: 'Pejotização',
        fn: async () =>
          setResultadoPejotizacao(
            await AuditoriaPejotizacaoService.buscarResultado({
              empresaId: Number(empresaId),
              periodo,
            })
          ),
      },
      {
        nome: 'Lançamento Manual',
        fn: async () =>
          setResultadoLancamentoManual(
            await AuditoriaLancamentoManualService.buscarResultado({
              empresaId: Number(empresaId),
              periodo,
            })
          ),
      },
      {
        nome: 'Lançamento Estorno',
        fn: async () =>
          setResultadoLancamentoEstorno(
            await AuditoriaLancamentoEstornoService.buscarResultado({
              empresaId: Number(empresaId),
              periodo,
            })
          ),
      },
      {
        nome: 'Lançamento Dia Não Útil',
        fn: async () =>
          setResultadoLancamentoDiaNaoUtil(
            await AuditoriaLancamentoDiaNaoUtilService.buscarResultado({
              empresaId: Number(empresaId),
              periodo,
            })
          ),
      },
      {
        nome: 'Despesa Analítica Relevante',
        fn: async () =>
          setResultadoDespesaAnaliticaRelevante(
            await AuditoriaDespesaAnaliticaRelevanteService.buscarResultado({
              empresaId: Number(empresaId),
              periodo,
            })
          ),
      },
      {
        nome: 'Lançamento Corretivo',
        fn: async () =>
          setResultadoLancamentoCorretivo(
            await AuditoriaLancamentoCorretivoService.buscarResultado({
              empresaId: Number(empresaId),
              periodo,
            })
          ),
      },
      {
        nome: 'Serviços Terceiros PF',
        fn: async () =>
          setResultadoServicosTerceirosPf(
            await AuditoriaServicosTerceirosPfService.buscarResultado({
              empresaId: Number(empresaId),
              periodo,
            })
          ),
      },
      {
        nome: 'Societária',
        fn: async () =>
          setResultadoSocietaria(
            await AuditoriaSocietariaService.buscarResultado({
              empresaId: Number(empresaId),
              periodo,
            })
          ),
      },
      {
        nome: 'Qualidade Históricos',
        fn: async () => {
          // DEVN3-593: na aba TODOS nao bloqueia esperando o processamento de uma empresa grande —
          // mostra o aviso "em processamento" e acompanha em segundo plano ate o resultado chegar.
          const params = {empresaId: Number(empresaId), periodo}
          const resultado = await AuditoriaQualidadeHistoricosService.buscarResultado(params, {aguardar: false})
          setResultadoQualidadeHistoricos(resultado)

          if (resultado.processando) {
            AuditoriaQualidadeHistoricosService.buscarResultado(params)
              .then(setResultadoQualidadeHistoricos)
              .catch(() => undefined)
          }
        },
      },
      {
        nome: 'Transfer Pricing',
        fn: async () =>
          setResultadoTransferPricing(
            await AuditoriaTransferPricingService.buscarResultado({
              empresaId: Number(empresaId),
              periodo,
            })
          ),
      },
      {
        nome: 'Cambial',
        fn: async () =>
          setResultadoCambial(
            await AuditoriaCambialService.buscarResultado({empresaId: Number(empresaId), periodo})
          ),
      },
      {
        nome: 'Round Tripping',
        fn: async () =>
          setResultadoRoundTripping(
            await AuditoriaRoundTrippingService.buscarResultado({
              empresaId: Number(empresaId),
              periodo,
            })
          ),
      },
      {
        nome: 'Cash Rich',
        fn: async () =>
          setResultadoCashRich(
            await AuditoriaCashRichService.buscarResultado({empresaId: Number(empresaId), periodo})
          ),
      },
      {
        nome: 'Mutação Volátil',
        fn: async () =>
          setResultadoMutacaoVolatil(
            await AuditoriaMutacaoVolatilService.buscarResultado({
              empresaId: Number(empresaId),
              periodo,
            })
          ),
      },
      {
        nome: 'Crédito Estagnado',
        fn: async () =>
          setResultadoCreditoEstagnado(
            await AuditoriaCreditoEstagnadoService.buscarResultado({
              empresaId: Number(empresaId),
              periodo,
            })
          ),
      },
      {
        nome: 'Provisão Espelho',
        fn: async () =>
          setResultadoProvisaoEspelho(
            await AuditoriaProvisaoEspelhoService.buscarResultado({
              empresaId: Number(empresaId),
              periodo,
            })
          ),
      },
      {
        nome: 'Correlação Receita',
        fn: async () =>
          setResultadoCorrelacaoReceita(
            await AuditoriaCorrelacaoReceitaService.buscarResultado({
              empresaId: Number(empresaId),
              periodo,
            })
          ),
      },
      {
        nome: 'Valor Redondo',
        fn: async () =>
          setResultadoValorRedondo(
            await AuditoriaValorRedondoService.buscarResultado({
              empresaId: Number(empresaId),
              periodo,
            })
          ),
      },
      {
        nome: 'Outras Despesas',
        fn: async () =>
          setResultadoOutrasDespesas(
            await AuditoriaOutrasDespesasService.buscarResultado({
              empresaId: Number(empresaId),
              periodo,
            })
          ),
      },
      {
        nome: 'Estoque Sem Movimento',
        fn: async () =>
          setResultadoEstoqueSemMovimento(
            await AuditoriaEstoqueSemMovimentoService.buscarResultado({
              empresaId: Number(empresaId),
              periodo,
            })
          ),
      },
      {
        nome: 'Split Despesas',
        fn: async () =>
          setResultadoSplitDespesas(
            await AuditoriaSplitDespesasService.buscarResultado({
              empresaId: Number(empresaId),
              periodo,
            })
          ),
      },
      {
        nome: 'Caixa Fornecedores',
        fn: async () =>
          setResultadoCaixaFornecedores(
            await AuditoriaCaixaFornecedoresService.buscarResultado({
              empresaId: Number(empresaId),
              periodo,
            })
          ),
      },
      {
        nome: 'Circularidade Transitória',
        fn: async () =>
          setResultadoCircularidadeTransitoria(
            await AuditoriaCircularidadeTransitoriaService.buscarResultado({
              empresaId: Number(empresaId),
              periodo,
            })
          ),
      },
      {
        nome: 'Correlação Fiscal',
        fn: async () =>
          setResultadoCorrelacaoFiscal(
            await AuditoriaCorrelacaoFiscalService.buscarResultado({
              empresaId: Number(empresaId),
              periodo,
            })
          ),
      },
      {
        nome: 'PL Integridade',
        fn: async () =>
          setResultadoPlIntegridade(
            await AuditoriaPlIntegridadeService.buscarResultado({
              empresaId: Number(empresaId),
              periodo,
            })
          ),
      },
      {
        nome: 'Payroll Drift',
        fn: async () =>
          setResultadoPayrollDrift(
            await AuditoriaPayrollDriftService.buscarResultado({
              empresaId: Number(empresaId),
              periodo,
            })
          ),
      },
      {
        nome: 'Asset Recovery',
        fn: async () =>
          setResultadoAssetRecovery(
            await AuditoriaAssetRecoveryService.buscarResultado({
              empresaId: Number(empresaId),
              periodo,
            })
          ),
      },
      {
        nome: 'Sim Capital',
        fn: async () =>
          setResultadoSimCapital(
            await AuditoriaSimCapitalService.buscarResultado({
              empresaId: Number(empresaId),
              periodo,
            })
          ),
      },
    ]

    // COR-186: concorrência limitada em vez de Promise.allSettled disparando todas de uma vez —
    // ver comentário completo em utils/concorrencia.ts. LIMITE alinhado ao teto de ~6 conexões
    // HTTP/1.1 simultâneas por origem que os navegadores aplicam por padrão.
    const LIMITE_CONCORRENCIA_MODULOS = 6
    const resultados = await executarComLimiteDeConcorrencia(
      passos.map((p) => p.fn),
      LIMITE_CONCORRENCIA_MODULOS
    )
    const falhas = resultados
      .map((r, i) => (r.status === 'rejected' ? passos[i].nome : null))
      .filter((n): n is string => n !== null)

    setFalhasCarregamento(falhas)
    setTotalModulosTentados(passos.length)

    if (falhas.length > 0) {
      console.error(
        '[Auditoria] Módulos com falha de carregamento:',
        falhas,
        resultados.filter((r) => r.status === 'rejected')
      )
      setErro(
        `Não foi possível carregar: ${falhas.join(
          ', '
        )}. Verifique o console (F12) para detalhes ou tente novamente.`
      )
    }
    setLoading(false)
  }

  const periodoSelecionado = periodos.find((x) => String(x.esteiraId) === periodo)
  const auditoriaSelecionada =
    !tributo || tributo === 'TODOS' ? undefined : resultado.cards.find((x) => x.tributo === tributo)

  const ehModuloNaoTributo =
    !!tributo &&
    tributo !== 'TODOS' &&
    tributo !== 'IRPJ' &&
    tributo !== 'CSLL' &&
    tributo !== 'PIS' &&
    tributo !== 'COFINS'

  return (
    <div className='auditoria-page'>
      <div className='auditoria-header-card'>
        <div className='d-flex justify-content-between mb-5'>
          <div>
            <h2 className='auditoria-title'>Revisor Contábil</h2>
            <p className='auditoria-subtitle'>
              Auditoria fiscal e bancária — provisões, compensações e saldos invertidos.
            </p>
          </div>
          <div
            className='btn-group'
            title={
              laudo?.exportHabilitado
                ? ''
                : 'Conclua a revisão do laudo para liberar a exportação.'
            }
          >
            <button
              className='btn btn-sm btn-primary'
              disabled={
                !laudo?.exportHabilitado || exportandoLaudo || !!laudo?.arquivoRetornoProcessando
              }
              onClick={() => exportarLaudo('PDF')}
            >
              {(exportandoLaudo || laudo?.arquivoRetornoProcessando) && (
                <span className='spinner-border spinner-border-sm me-1' />
              )}
              Exportar Laudo (PDF)
            </button>
            <button
              className='btn btn-sm btn-outline-primary'
              disabled={
                !laudo?.exportHabilitado || exportandoLaudo || !!laudo?.arquivoRetornoProcessando
              }
              onClick={() => exportarLaudo('DOCX')}
            >
              Word
            </button>
          </div>
        </div>
        {!tierCarregando && tier !== 'Nenhum' && (
          <AuditoriaFiltros
            empresas={empresas}
            periodos={periodos}
            empresaId={empresaId}
            periodo={periodo}
            tributo={tributo}
            onEmpresaChange={(id) => {
              setEmpresaId(id)
              setPeriodo(undefined)
              setTributo(tier === 'Diagnostico' ? 'TODOS' : '')
              setResultado({cards: [], empresas: []})
            }}
            onPeriodoChange={(value) => {
              setPeriodo(value)
              setTributo(tier === 'Diagnostico' ? 'TODOS' : '')
            }}
            onTributoChange={selecionarTributo}
            modoSomenteTodos={tier === 'Diagnostico'}
            tributosPermitidos={tier === 'Trial72h' ? TRIBUTOS_PERMITIDOS_TRIAL : undefined}
          />
        )}
      </div>

      <AuditoriaTierBanner tier={tier} />

      {tierCarregando && <div className='auditoria-card'>Carregando...</div>}

      {!tierCarregando && tier === 'Nenhum' && (
        <div className='auditoria-card auditoria-empty-state text-center py-10'>
          <button
            className='btn btn-primary'
            onClick={() =>
              solicitarDemonstracaoSeBloqueado('Revisor Contábil', () => history.push('/dashboard'))
            }
          >
            Agendar demonstração
          </button>
        </div>
      )}

      {!tierCarregando && tier !== 'Nenhum' && (
        <>
          {erro && <div className='alert alert-danger mt-5'>{erro}</div>}

          <div className='auditoria-layout'>
            <aside className='auditoria-sidebar-card'>
              <h4>Contexto da Auditoria</h4>
              <div className='auditoria-meta-item'>
                <span>Empresas</span>
                <strong>
                  {empresaId
                    ? `Exibindo dados de 1 empresa de ${empresas.length} cadastrada${
                        empresas.length === 1 ? '' : 's'
                      }`
                    : `Nenhuma selecionada de ${empresas.length} cadastrada${
                        empresas.length === 1 ? '' : 's'
                      }`}
                </strong>
              </div>
              <div className='auditoria-meta-item'>
                <span>Período</span>
                <strong>{periodoSelecionado?.descricao || '-'}</strong>
              </div>
              <div className='auditoria-meta-item'>
                <span>Conta Auditada</span>
                <strong>{tributo ? obterLabelTributo(tributo) : '-'}</strong>
              </div>
            </aside>

            <main>
              {empresaId && periodo && (
                <AuditoriaCircularizacaoBarraProgressao
                  periodo={periodo}
                  onGerenciar={() =>
                    history.push({ pathname: '/auditoria/circularizacao', state: { empresaId, periodo } })
                  }
                  onResolverPendencia={(categoria) =>
                    history.push({
                      pathname: `/auditoria/circularizacao/${categoriaParaSlug(categoria)}`,
                      state: { empresaId, periodo, abaInicial: 'PLANEJAMENTO' },
                    })
                  }
                />
              )}
              {laudo && (
                <AuditoriaLaudoBarraProgressao
                  laudo={laudo}
                  onRevisar={() =>
                    history.push(`/auditoria/revisao?empresa=${empresaId}&periodo=${periodo}`)
                  }
                />
              )}
              {loading && <div className='auditoria-card'>Carregando...</div>}
              {!loading && !empresaId && (
                <div className='auditoria-card auditoria-empty-state'>
                  Selecione uma empresa para carregar a auditoria.
                </div>
              )}
              {!loading && empresaId && !periodo && (
                <div className='auditoria-card auditoria-empty-state'>
                  Selecione um período para visualizar os dados da auditoria.
                </div>
              )}
              {!loading && empresaId && periodo && !tributo && (
                <div className='auditoria-card auditoria-empty-state'>
                  Selecione o tipo de auditoria (TODOS ou um módulo individual) para carregar os
                  dados.
                </div>
              )}

              {!loading && empresaId && periodo && tributo === 'TODOS' && (
                <>
                  <AuditoriaResumoGeral
                    resultado={resultado}
                    empresas={empresas}
                    empresaId={empresaId}
                    falhasCarregamento={falhasCarregamento}
                    totalModulosTentados={totalModulosTentados}
                    resultadoBancario={resultadoBancario}
                    resultadoDepreciacao={resultadoDepreciacao}
                    resultadoCaixa={resultadoCaixa}
                    resultadoFinanceira={resultadoFinanceira}
                    resultadoZeramento13={resultadoZeramento13}
                    resultadoBaixaPatrimonial={resultadoBaixaPatrimonial}
                    resultadoAdiantamento={resultadoAdiantamento}
                    resultadoAdiantamentoClientes={resultadoAdiantamentoClientes}
                    resultadoDespesasAntecipadas={resultadoDespesasAntecipadas}
                    resultadoAjusteExerciciosAnteriores={resultadoAjusteExerciciosAnteriores}
                    resultadoContasPagarReceber={resultadoContasPagarReceber}
                    resultadoFornecedoresConciliacao={resultadoFornecedoresConciliacao}
                    resultadoReceitasDiferidas={resultadoReceitasDiferidas}
                    resultadoIntegridadeLancamentos={resultadoIntegridadeLancamentos}
                    resultadoAdiantamentoSocios={resultadoAdiantamentoSocios}
                    resultadoBeneficiosIndiretos={resultadoBeneficiosIndiretos}
                    resultadoRastreabilidadeBancaria={resultadoRastreabilidadeBancaria}
                    resultadoArredondamentosAjustes={resultadoArredondamentosAjustes}
                    resultadoAdiantamentoFuncionarios={resultadoAdiantamentoFuncionarios}
                    resultadoAdiantamentoSalario={resultadoAdiantamentoSalario}
                    resultadoAnomaliaTarifaBancaria={resultadoAnomaliaTarifaBancaria}
                    resultadoContaTransitoria={resultadoContaTransitoria}
                    resultadoAdiantamentoViagem={resultadoAdiantamentoViagem}
                    resultadoClassificacaoReceita={resultadoClassificacaoReceita}
                    resultadoProvisaoPisCofins={resultadoProvisaoPisCofins}
                    resultadoProvisaoIss={resultadoProvisaoIss}
                    resultadoProvisaoIcms={resultadoProvisaoIcms}
                    resultadoDuplicidadePagamentos={resultadoDuplicidadePagamentos}
                    resultadoRotatividadeProvisoes={resultadoRotatividadeProvisoes}
                    resultadoPddAnalitica={resultadoPddAnalitica}
                    resultadoPejotizacao={resultadoPejotizacao}
                    resultadoLancamentoManual={resultadoLancamentoManual}
                    resultadoLancamentoEstorno={resultadoLancamentoEstorno}
                    resultadoLancamentoDiaNaoUtil={resultadoLancamentoDiaNaoUtil}
                    resultadoDespesaAnaliticaRelevante={resultadoDespesaAnaliticaRelevante}
                    resultadoLancamentoCorretivo={resultadoLancamentoCorretivo}
                    resultadoServicosTerceirosPf={resultadoServicosTerceirosPf}
                    resultadoSocietaria={resultadoSocietaria}
                    resultadoQualidadeHistoricos={resultadoQualidadeHistoricos}
                    resultadoTransferPricing={resultadoTransferPricing}
                    resultadoCambial={resultadoCambial}
                    resultadoRoundTripping={resultadoRoundTripping}
                    resultadoCashRich={resultadoCashRich}
                    resultadoMutacaoVolatil={resultadoMutacaoVolatil}
                    resultadoCreditoEstagnado={resultadoCreditoEstagnado}
                    resultadoProvisaoEspelho={resultadoProvisaoEspelho}
                    resultadoCorrelacaoReceita={resultadoCorrelacaoReceita}
                    resultadoValorRedondo={resultadoValorRedondo}
                    resultadoOutrasDespesas={resultadoOutrasDespesas}
                    resultadoEstoqueSemMovimento={resultadoEstoqueSemMovimento}
                    resultadoSplitDespesas={resultadoSplitDespesas}
                    resultadoCaixaFornecedores={resultadoCaixaFornecedores}
                    resultadoCircularidadeTransitoria={resultadoCircularidadeTransitoria}
                    resultadoCorrelacaoFiscal={resultadoCorrelacaoFiscal}
                    resultadoPlIntegridade={resultadoPlIntegridade}
                    resultadoPayrollDrift={resultadoPayrollDrift}
                    resultadoAssetRecovery={resultadoAssetRecovery}
                    resultadoSimCapital={resultadoSimCapital}
                  />
                  <AuditoriaTabelaTributos
                    cards={resultado.cards}
                    onSelecionarTributo={selecionarTributo}
                  />
                  <AuditoriaResumoBancario
                    resultado={resultadoBancario}
                    onSelecionar={selecionarTributo}
                  />
                  <AuditoriaResumoDepreciacao
                    resultado={resultadoDepreciacao}
                    onSelecionar={selecionarTributo}
                  />
                  <AuditoriaResumoCaixa
                    resultado={resultadoCaixa}
                    onSelecionar={selecionarTributo}
                  />
                  <AuditoriaResumoFinanceira
                    resultado={resultadoFinanceira}
                    onSelecionar={selecionarTributo}
                  />
                  <AuditoriaResumoZeramento13
                    resultado={resultadoZeramento13}
                    onSelecionar={selecionarTributo}
                  />
                  <AuditoriaResumoBaixaPatrimonial
                    resultado={resultadoBaixaPatrimonial}
                    onSelecionar={selecionarTributo}
                  />
                  <AuditoriaResumoAdiantamento
                    resultado={resultadoAdiantamento}
                    onSelecionar={selecionarTributo}
                  />
                  <AuditoriaResumoAdiantamentoClientes
                    resultado={resultadoAdiantamentoClientes}
                    onSelecionar={selecionarTributo}
                  />
                  <AuditoriaResumoDespesasAntecipadas
                    resultado={resultadoDespesasAntecipadas}
                    onSelecionar={selecionarTributo}
                  />
                  <AuditoriaResumoAjusteExerciciosAnteriores
                    resultado={resultadoAjusteExerciciosAnteriores}
                    onSelecionar={selecionarTributo}
                  />
                  <AuditoriaResumoContasPagarReceber
                    resultado={resultadoContasPagarReceber}
                    onSelecionar={selecionarTributo}
                  />
                  <AuditoriaResumoFornecedoresConciliacao
                    resultado={resultadoFornecedoresConciliacao}
                    onSelecionar={selecionarTributo}
                  />
                  <AuditoriaResumoReceitasDiferidas
                    resultado={resultadoReceitasDiferidas}
                    onSelecionar={selecionarTributo}
                  />
                  <AuditoriaResumoIntegridadeLancamentos
                    resultado={resultadoIntegridadeLancamentos}
                    onSelecionar={selecionarTributo}
                  />
                  <AuditoriaResumoAdiantamentoSocios
                    resultado={resultadoAdiantamentoSocios}
                    onSelecionar={selecionarTributo}
                  />
                  <AuditoriaResumoBeneficiosIndiretos
                    resultado={resultadoBeneficiosIndiretos}
                    onSelecionar={selecionarTributo}
                  />
                  <AuditoriaResumoRastreabilidadeBancaria
                    resultado={resultadoRastreabilidadeBancaria}
                    onSelecionar={selecionarTributo}
                  />
                  <AuditoriaResumoArredondamentosAjustes
                    resultado={resultadoArredondamentosAjustes}
                    onSelecionar={selecionarTributo}
                  />
                  <AuditoriaResumoAdiantamentoFuncionarios
                    resultado={resultadoAdiantamentoFuncionarios}
                    onSelecionar={selecionarTributo}
                  />
                  <AuditoriaResumoAdiantamentoSalario
                    resultado={resultadoAdiantamentoSalario}
                    onSelecionar={selecionarTributo}
                  />
                  <AuditoriaResumoAnomaliaTarifaBancaria
                    resultado={resultadoAnomaliaTarifaBancaria}
                    onSelecionar={selecionarTributo}
                  />
                  <AuditoriaResumoContaTransitoria
                    resultado={resultadoContaTransitoria}
                    onSelecionar={selecionarTributo}
                  />
                  <AuditoriaResumoAdiantamentoViagem
                    resultado={resultadoAdiantamentoViagem}
                    onSelecionar={selecionarTributo}
                  />
                  <AuditoriaResumoClassificacaoReceita
                    resultado={resultadoClassificacaoReceita}
                    onSelecionar={selecionarTributo}
                  />
                  <AuditoriaResumoProvisaoPisCofins
                    resultado={resultadoProvisaoPisCofins}
                    onSelecionar={selecionarTributo}
                  />
                  <AuditoriaResumoProvisaoIss
                    resultado={resultadoProvisaoIss}
                    onSelecionar={selecionarTributo}
                  />
                  <AuditoriaResumoProvisaoIcms
                    resultado={resultadoProvisaoIcms}
                    onSelecionar={selecionarTributo}
                  />
                  <AuditoriaResumoDuplicidadePagamentos
                    resultado={resultadoDuplicidadePagamentos}
                    onSelecionar={selecionarTributo}
                  />
                  <AuditoriaResumoRotatividadeProvisoes
                    resultado={resultadoRotatividadeProvisoes}
                    onSelecionar={selecionarTributo}
                  />
                  <AuditoriaResumoPddAnalitica
                    resultado={resultadoPddAnalitica}
                    onSelecionar={selecionarTributo}
                  />
                  <AuditoriaResumoPejotizacao
                    resultado={resultadoPejotizacao}
                    onSelecionar={selecionarTributo}
                  />
                  <AuditoriaResumoLancamentoManual
                    resultado={resultadoLancamentoManual}
                    onSelecionar={selecionarTributo}
                  />
                  <AuditoriaResumoLancamentoEstorno
                    resultado={resultadoLancamentoEstorno}
                    onSelecionar={selecionarTributo}
                  />
                  <AuditoriaResumoLancamentoDiaNaoUtil
                    resultado={resultadoLancamentoDiaNaoUtil}
                    onSelecionar={selecionarTributo}
                  />
                  <AuditoriaResumoDespesaAnaliticaRelevante
                    resultado={resultadoDespesaAnaliticaRelevante}
                    onSelecionar={selecionarTributo}
                  />
                  <AuditoriaResumoLancamentoCorretivo
                    resultado={resultadoLancamentoCorretivo}
                    onSelecionar={selecionarTributo}
                  />
                  <AuditoriaResumoServicosTerceirosPf
                    resultado={resultadoServicosTerceirosPf}
                    onSelecionar={selecionarTributo}
                  />
                  <AuditoriaResumoSocietaria
                    resultado={resultadoSocietaria}
                    onSelecionar={selecionarTributo}
                  />
                  <AuditoriaResumoQualidadeHistoricos
                    resultado={resultadoQualidadeHistoricos}
                    onSelecionar={selecionarTributo}
                  />
                  <AuditoriaResumoTransferPricing
                    resultado={resultadoTransferPricing}
                    onSelecionar={selecionarTributo}
                  />
                  <AuditoriaResumoCambial
                    resultado={resultadoCambial}
                    onSelecionar={selecionarTributo}
                  />
                  <AuditoriaResumoRoundTripping
                    resultado={resultadoRoundTripping}
                    onSelecionar={selecionarTributo}
                  />
                  <AuditoriaResumoCashRich
                    resultado={resultadoCashRich}
                    onSelecionar={selecionarTributo}
                  />
                  <AuditoriaResumoMutacaoVolatil
                    resultado={resultadoMutacaoVolatil}
                    onSelecionar={selecionarTributo}
                  />
                  <AuditoriaResumoCreditoEstagnado
                    resultado={resultadoCreditoEstagnado}
                    onVerDetalhe={() => setTributo('AUDITORIA_CREDITO_ESTAGNADO')}
                  />
                  <AuditoriaResumoProvisaoEspelho
                    resultado={resultadoProvisaoEspelho}
                    onVerDetalhe={() => setTributo('AUDITORIA_PROVISAO_ESPELHO')}
                  />
                  <AuditoriaResumoCorrelacaoReceita
                    resultado={resultadoCorrelacaoReceita}
                    onVerDetalhe={() => setTributo('AUDITORIA_CORRELACAO_RECEITA')}
                  />
                  <AuditoriaResumoValorRedondo
                    resultado={resultadoValorRedondo}
                    onVerDetalhe={() => setTributo('AUDITORIA_VALOR_REDONDO')}
                  />
                  <AuditoriaResumoOutrasDespesas
                    resultado={resultadoOutrasDespesas}
                    onVerDetalhe={() => setTributo('AUDITORIA_OUTRAS_DESPESAS')}
                  />
                  <AuditoriaResumoEstoqueSemMovimento
                    resultado={resultadoEstoqueSemMovimento}
                    onVerDetalhe={() => setTributo('AUDITORIA_ESTOQUE_SEM_MOVIMENTO')}
                  />
                  <AuditoriaResumoSplitDespesas
                    resultado={resultadoSplitDespesas}
                    onVerDetalhe={() => setTributo('AUDITORIA_SPLIT_DESPESAS')}
                  />
                  <AuditoriaResumoCaixaFornecedores
                    resultado={resultadoCaixaFornecedores}
                    onVerDetalhe={() => setTributo('AUDITORIA_CAIXA_FORNECEDORES')}
                  />
                  <AuditoriaResumoCircularidadeTransitoria
                    resultado={resultadoCircularidadeTransitoria}
                    onVerDetalhe={() => setTributo('AUDITORIA_CIRCULARIDADE_TRANSITORIA')}
                  />
                  <AuditoriaResumoCorrelacaoFiscal
                    resultado={resultadoCorrelacaoFiscal}
                    onVerDetalhe={() => setTributo('AUDITORIA_CORRELACAO_FISCAL')}
                  />
                  <AuditoriaResumoPlIntegridade
                    resultado={resultadoPlIntegridade}
                    onVerDetalhe={() => setTributo('AUDITORIA_PL_INTEGRIDADE')}
                  />
                  <AuditoriaResumoPayrollDrift
                    resultado={resultadoPayrollDrift}
                    onVerDetalhe={() => setTributo('AUDITORIA_PAYROLL_DRIFT')}
                  />
                  <AuditoriaResumoAssetRecovery
                    resultado={resultadoAssetRecovery}
                    onVerDetalhe={() => setTributo('AUDITORIA_ASSET_RECOVERY')}
                  />
                  <AuditoriaResumoSimCapital
                    resultado={resultadoSimCapital}
                    onVerDetalhe={() => setTributo('AUDITORIA_SIM_CAPITAL')}
                  />
                </>
              )}

              {!loading && empresaId && periodo && tributo === 'SALDOS_BANCARIOS' && (
                <AuditoriaSaldosBancarios resultado={resultadoBancario} />
              )}
              {!loading && empresaId && periodo && tributo === 'DEPRECIACAO_AMORTIZACAO' && (
                <AuditoriaDepreciacaoDetalhe resultado={resultadoDepreciacao} />
              )}
              {!loading && empresaId && periodo && tributo === 'AUDITORIA_CAIXA' && (
                <AuditoriaCaixaDetalhe resultado={resultadoCaixa} />
              )}
              {!loading && empresaId && periodo && tributo === 'AUDITORIA_FINANCEIRA' && (
                <AuditoriaFinanceiraDetalhe resultado={resultadoFinanceira} />
              )}
              {!loading && empresaId && periodo && tributo === 'AUDITORIA_ZERAMENTO_13' && (
                <AuditoriaZeramento13Detalhe resultado={resultadoZeramento13} />
              )}
              {!loading && empresaId && periodo && tributo === 'AUDITORIA_BAIXA_PATRIMONIAL' && (
                <AuditoriaBaixaPatrimonialDetalhe resultado={resultadoBaixaPatrimonial} />
              )}
              {!loading && empresaId && periodo && tributo === 'AUDITORIA_ADIANTAMENTO' && (
                <AuditoriaAdiantamentoDetalhe resultado={resultadoAdiantamento} />
              )}
              {!loading &&
                empresaId &&
                periodo &&
                tributo === 'AUDITORIA_ADIANTAMENTO_CLIENTES' && (
                  <AuditoriaAdiantamentoClientesDetalhe resultado={resultadoAdiantamentoClientes} />
                )}
              {!loading && empresaId && periodo && tributo === 'AUDITORIA_DESPESAS_ANTECIPADAS' && (
                <AuditoriaDespesasAntecipadasDetalhe resultado={resultadoDespesasAntecipadas} />
              )}
              {!loading &&
                empresaId &&
                periodo &&
                tributo === 'AUDITORIA_AJUSTE_EXERCICIOS_ANTERIORES' && (
                  <AuditoriaAjusteExerciciosAnterioresDetalhe
                    resultado={resultadoAjusteExerciciosAnteriores}
                  />
                )}
              {!loading && empresaId && periodo && tributo === 'AUDITORIA_CONTAS_PAGAR_RECEBER' && (
                <AuditoriaContasPagarReceberDetalhe resultado={resultadoContasPagarReceber} />
              )}
              {!loading &&
                empresaId &&
                periodo &&
                tributo === 'AUDITORIA_FORNECEDORES_CONCILIACAO' && (
                  <AuditoriaFornecedoresConciliacaoDetalhe
                    resultado={resultadoFornecedoresConciliacao}
                  />
                )}
              {!loading && empresaId && periodo && tributo === 'AUDITORIA_RECEITAS_DIFERIDAS' && (
                <AuditoriaReceitasDiferidasDetalhe resultado={resultadoReceitasDiferidas} />
              )}
              {!loading &&
                empresaId &&
                periodo &&
                tributo === 'AUDITORIA_INTEGRIDADE_LANCAMENTOS' && (
                  <AuditoriaIntegridadeLancamentosDetalhe
                    resultado={resultadoIntegridadeLancamentos}
                  />
                )}
              {!loading && empresaId && periodo && tributo === 'AUDITORIA_ADIANTAMENTO_SOCIOS' && (
                <AuditoriaAdiantamentoSociosDetalhe resultado={resultadoAdiantamentoSocios} />
              )}
              {!loading && empresaId && periodo && tributo === 'AUDITORIA_BENEFICIOS_INDIRETOS' && (
                <AuditoriaBeneficiosIndiretosDetalhe
                  resultado={resultadoBeneficiosIndiretos}
                  periodo={periodo}
                />
              )}
              {!loading &&
                empresaId &&
                periodo &&
                tributo === 'AUDITORIA_RASTREABILIDADE_BANCARIA' && (
                  <AuditoriaRastreabilidadeBancariaDetalhe
                    resultado={resultadoRastreabilidadeBancaria}
                    empresaId={empresaId}
                    periodo={periodo}
                  />
                )}
              {!loading &&
                empresaId &&
                periodo &&
                tributo === 'AUDITORIA_ARREDONDAMENTOS_AJUSTES' && (
                  <AuditoriaArredondamentosAjustesDetalhe
                    resultado={resultadoArredondamentosAjustes}
                  />
                )}
              {!loading &&
                empresaId &&
                periodo &&
                tributo === 'AUDITORIA_ADIANTAMENTO_FUNCIONARIOS' && (
                  <AuditoriaAdiantamentoFuncionariosDetalhe
                    resultado={resultadoAdiantamentoFuncionarios}
                  />
                )}
              {!loading && empresaId && periodo && tributo === 'AUDITORIA_ADIANTAMENTO_SALARIO' && (
                <AuditoriaAdiantamentoSalarioDetalhe resultado={resultadoAdiantamentoSalario} />
              )}
              {!loading &&
                empresaId &&
                periodo &&
                tributo === 'AUDITORIA_ANOMALIA_TARIFA_BANCARIA' && (
                  <AuditoriaAnomaliaTarifaBancariaDetalhe
                    resultado={resultadoAnomaliaTarifaBancaria}
                  />
                )}
              {!loading && empresaId && periodo && tributo === 'AUDITORIA_CONTA_TRANSITORIA' && (
                <AuditoriaContaTransitoriaDetalhe resultado={resultadoContaTransitoria} />
              )}
              {!loading && empresaId && periodo && tributo === 'AUDITORIA_ADIANTAMENTO_VIAGEM' && (
                <AuditoriaAdiantamentoViagemDetalhe resultado={resultadoAdiantamentoViagem} />
              )}
              {!loading &&
                empresaId &&
                periodo &&
                tributo === 'AUDITORIA_CLASSIFICACAO_RECEITA' && (
                  <AuditoriaClassificacaoReceitaDetalhe resultado={resultadoClassificacaoReceita} />
                )}
              {!loading && empresaId && periodo && tributo === 'AUDITORIA_PROVISAO_PIS_COFINS' && (
                <AuditoriaProvisaoPisCofinsDetalhe resultado={resultadoProvisaoPisCofins} />
              )}
              {!loading && empresaId && periodo && tributo === 'AUDITORIA_PROVISAO_ISS' && (
                <AuditoriaProvisaoIssDetalhe resultado={resultadoProvisaoIss} />
              )}
              {!loading && empresaId && periodo && tributo === 'AUDITORIA_PROVISAO_ICMS' && (
                <AuditoriaProvisaoIcmsDetalhe resultado={resultadoProvisaoIcms} />
              )}
              {!loading &&
                empresaId &&
                periodo &&
                tributo === 'AUDITORIA_DUPLICIDADE_PAGAMENTOS' && (
                  <AuditoriaDuplicidadePagamentosDetalhe
                    resultado={resultadoDuplicidadePagamentos}
                  />
                )}
              {!loading &&
                empresaId &&
                periodo &&
                tributo === 'AUDITORIA_ROTATIVIDADE_PROVISOES' && (
                  <AuditoriaRotatividadeProvisoesDetalhe
                    resultado={resultadoRotatividadeProvisoes}
                  />
                )}
              {!loading && empresaId && periodo && tributo === 'AUDITORIA_PDD_ANALITICA' && (
                <AuditoriaPddAnaliticaDetalhe resultado={resultadoPddAnalitica} />
              )}
              {!loading && empresaId && periodo && tributo === 'AUDITORIA_PEJOTIZACAO' && (
                <AuditoriaPejotizacaoDetalhe resultado={resultadoPejotizacao} />
              )}
              {!loading && empresaId && periodo && tributo === 'AUDITORIA_LANCAMENTO_MANUAL' && (
                <AuditoriaLancamentoManualDetalhe resultado={resultadoLancamentoManual} />
              )}
              {!loading && empresaId && periodo && tributo === 'AUDITORIA_LANCAMENTO_ESTORNO' && (
                <AuditoriaLancamentoEstornoDetalhe resultado={resultadoLancamentoEstorno} />
              )}
              {!loading &&
                empresaId &&
                periodo &&
                tributo === 'AUDITORIA_LANCAMENTO_DIA_NAO_UTIL' && (
                  <AuditoriaLancamentoDiaNaoUtilDetalhe resultado={resultadoLancamentoDiaNaoUtil} />
                )}
              {!loading &&
                empresaId &&
                periodo &&
                tributo === 'AUDITORIA_DESPESA_ANALITICA_RELEVANTE' && (
                  <AuditoriaDespesaAnaliticaRelevanteDetalhe
                    resultado={resultadoDespesaAnaliticaRelevante}
                  />
                )}
              {!loading && empresaId && periodo && tributo === 'AUDITORIA_LANCAMENTO_CORRETIVO' && (
                <AuditoriaLancamentoCorretivoDetalhe resultado={resultadoLancamentoCorretivo} />
              )}
              {!loading &&
                empresaId &&
                periodo &&
                tributo === 'AUDITORIA_SERVICOS_TERCEIROS_PF' && (
                  <AuditoriaServicosTerceirosPfDetalhe resultado={resultadoServicosTerceirosPf} />
                )}
              {!loading && empresaId && periodo && tributo === 'AUDITORIA_SOCIETARIA' && (
                <AuditoriaSocietariaDetalhe resultado={resultadoSocietaria} />
              )}
              {loading && qualidadeProcessando && tributo === 'AUDITORIA_QUALIDADE_HISTORICOS' && (
                <div className='auditoria-alert status-AVISO'>
                  <i className='bi bi-hourglass-split auditoria-alert-icon' />
                  <div>
                    <strong>Auditoria em processamento</strong>
                    <div>
                      Esta empresa/período tem um grande volume de lançamentos. O resultado está sendo calculado e
                      aparecerá aqui automaticamente assim que concluir — pode levar alguns minutos.
                    </div>
                  </div>
                </div>
              )}
              {!loading && empresaId && periodo && tributo === 'AUDITORIA_QUALIDADE_HISTORICOS' && (
                <AuditoriaQualidadeHistoricosDetalhe resultado={resultadoQualidadeHistoricos} />
              )}
              {!loading && empresaId && periodo && tributo === 'AUDITORIA_TRANSFER_PRICING' && (
                <AuditoriaTransferPricingDetalhe resultado={resultadoTransferPricing} />
              )}
              {!loading && empresaId && periodo && tributo === 'AUDITORIA_CAMBIAL' && (
                <AuditoriaCambialDetalhe resultado={resultadoCambial} />
              )}
              {!loading && empresaId && periodo && tributo === 'AUDITORIA_ROUND_TRIPPING' && (
                <AuditoriaRoundTrippingDetalhe resultado={resultadoRoundTripping} />
              )}
              {!loading && empresaId && periodo && tributo === 'AUDITORIA_CASH_RICH' && (
                <AuditoriaCashRichDetalhe resultado={resultadoCashRich} />
              )}
              {!loading && empresaId && periodo && tributo === 'AUDITORIA_MUTACAO_VOLATIL' && (
                <AuditoriaMutacaoVolatilDetalhe resultado={resultadoMutacaoVolatil} />
              )}
              {!loading && empresaId && periodo && tributo === 'AUDITORIA_CREDITO_ESTAGNADO' && (
                <AuditoriaCreditoEstagnadoDetalhe resultado={resultadoCreditoEstagnado} />
              )}
              {!loading && empresaId && periodo && tributo === 'AUDITORIA_PROVISAO_ESPELHO' && (
                <AuditoriaProvisaoEspelhoDetalhe resultado={resultadoProvisaoEspelho} />
              )}
              {!loading && empresaId && periodo && tributo === 'AUDITORIA_CORRELACAO_RECEITA' && (
                <AuditoriaCorrelacaoReceitaDetalhe resultado={resultadoCorrelacaoReceita} />
              )}
              {!loading && empresaId && periodo && tributo === 'AUDITORIA_VALOR_REDONDO' && (
                <AuditoriaValorRedondoDetalhe resultado={resultadoValorRedondo} />
              )}
              {!loading && empresaId && periodo && tributo === 'AUDITORIA_OUTRAS_DESPESAS' && (
                <AuditoriaOutrasDespesasDetalhe resultado={resultadoOutrasDespesas} />
              )}
              {!loading &&
                empresaId &&
                periodo &&
                tributo === 'AUDITORIA_ESTOQUE_SEM_MOVIMENTO' && (
                  <AuditoriaEstoqueSemMovimentoDetalhe resultado={resultadoEstoqueSemMovimento} />
                )}
              {!loading && empresaId && periodo && tributo === 'AUDITORIA_SPLIT_DESPESAS' && (
                <AuditoriaSplitDespesasDetalhe resultado={resultadoSplitDespesas} />
              )}
              {!loading && empresaId && periodo && tributo === 'AUDITORIA_CAIXA_FORNECEDORES' && (
                <AuditoriaCaixaFornecedoresDetalhe resultado={resultadoCaixaFornecedores} />
              )}
              {!loading &&
                empresaId &&
                periodo &&
                tributo === 'AUDITORIA_CIRCULARIDADE_TRANSITORIA' && (
                  <AuditoriaCircularidadeTransitoriaDetalhe
                    resultado={resultadoCircularidadeTransitoria}
                  />
                )}
              {!loading && empresaId && periodo && tributo === 'AUDITORIA_CORRELACAO_FISCAL' && (
                <AuditoriaCorrelacaoFiscalDetalhe resultado={resultadoCorrelacaoFiscal} />
              )}
              {!loading && empresaId && periodo && tributo === 'AUDITORIA_PL_INTEGRIDADE' && (
                <AuditoriaPlIntegridadeDetalhe resultado={resultadoPlIntegridade} />
              )}
              {!loading && empresaId && periodo && tributo === 'AUDITORIA_PAYROLL_DRIFT' && (
                <AuditoriaPayrollDriftDetalhe resultado={resultadoPayrollDrift} />
              )}
              {!loading && empresaId && periodo && tributo === 'AUDITORIA_ASSET_RECOVERY' && (
                <AuditoriaAssetRecoveryDetalhe resultado={resultadoAssetRecovery} />
              )}
              {!loading && empresaId && periodo && tributo === 'AUDITORIA_SIM_CAPITAL' && (
                <AuditoriaSimCapitalDetalhe resultado={resultadoSimCapital} />
              )}

              {!loading && empresaId && periodo && tributo !== 'TODOS' && !ehModuloNaoTributo && (
                <AuditoriaDetalheTributo auditoria={auditoriaSelecionada} />
              )}

            </main>
          </div>
        </>
      )}
    </div>
  )
}

export default AuditoriaPage
